import React from "react";
import moment from "moment";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader,
    TextArea
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import config from "../../../config.js";
const storageBaseUrl = config["storage_base_url"];
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../CheckboxView.jsx";
import { fetchAutomationStatusData, runSmartspotAutomationScript, fetchUseraction, 
    getDisbursementFormulas, updateDisbursementFormulas, fetchTemplates, 
    getWorkingFiles,rawFileProcess,getSplitFilesFormulas,
    updateSplitFileFormulas,
    processApprovedFiles,
    splitSitewiseProcess,
    sendWorkingFiles,
    processCreditNote,
    sendCreditNoteFiles,
    splitSmartspotfiles,
    getSmartspotSplitStatus,
    updateSmartspotDistInfo,
    getSmartspotsplittedFiles,
    smartspotSendWorkingFiles,
    processSmartspotCreditNote,
    sendSmartspotCreditNoteFiles,
    checkSmartspotInputData,
    checkSmartspotFinalReportInputs,
    getSmartspotPlanData,
    extractSmartspotTemplateCol,
    extractsmartspotTemplateCol,
    saveSmartspotTemplateCol,
    savesmartspotTemplateCol,
    getSmartspotTemplateConditions,
    compareSmartspotTemplateColumns,
    getSmartspotPreviousMonthTemplate,
    getsmartspotTemplateConditions,
    runSmartspotFinalReportAutomationScript,
    fetchSmartspotFinalReportAutomationStatus,
    clearSmartspotFinalReportFailedStatus,
} from '../../../actions/users_action';

var apiTimeout = null

// Sheet names inside the single smartspotTemplate file.
// sheetName is what gets sent to the API and used as the DB colConditions key.
const SMARTSPOT_PHASE2_TEMPLATES = [
    { key: 'nonAuditing', label: 'Non Auditing', sheetName: 'Non Auditing',  statusKey: 'nonAuditingFileStatus', urlKey: 'nonAuditingFileUrl' },
    { key: 'adaptiveTt',  label: 'Adaptive TT',  sheetName: 'Adaptive TT',   statusKey: 'adaptiveTtFileStatus',  urlKey: 'adaptiveTtFileUrl' },
    { key: 'adaptiveTot', label: 'Adaptive TOT', sheetName: 'Adaptive TOT',  statusKey: 'adaptiveTotFileStatus', urlKey: 'adaptiveTotFileUrl' },
    { key: 'chainStores', label: 'Chain Stores', sheetName: 'Chain Stores',  statusKey: 'chainStoresFileStatus', urlKey: 'chainStoresFileUrl' },
]

// The single DB fileName used for the Smartspot template file
const PHASE2_TEMPLATE_FILE_NAME = 'smartspotTemplate'
class SmartspotAutomation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            standaloneOutputUrls: {
                physical_seller: '',
                seller: ''
            },
            standaloneStatusByType: {
                physical_seller: 'Pending',
                seller: 'Pending'
            },
            standaloneUpdatedAtByType: {
                physical_seller: null,
                seller: null
            },
            restartConfirmOpen: false,
            standaloneModalOpen: false,
            auditType: '',
            processingStartTime: null,
            templateId: "",
            distributors: [],
            selectedDistributor: [],
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles:[],
            modalOpen:false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            workingFiles:[],
            auditingSplit:[],
            nonAuditingSplit:[],
            formulasType:'',
            loaderStatus:false,
            selectedDist:{},
            disType:'Smartspot',
            splitBtn:true,
            missingFiles:[],
            inputStatusList:[],
            validationModelOpen: false,
            proceed: false,
            inputFilesModalOpen: false,
            inputFileStatusList: [],
            uploadingFileName: null,
            planDataModalOpen: false,
            planDataUrl: '',
            planDataStatus: 'Yet to Upload',
            templateModalOpen: false,
            templateDataUrl: '',
            templateStatus: 'Yet to Upload',
            mappingFileModalOpen: false,
            mappingFileUrl: '',
            mappingFileStatus: 'Yet to Upload',
            mappingFileUploaded: false,
            mappingCurrentFile: {},
            templateCol: [],
            templateColModal: false,
            templateComparisonModalOpen: false,
            comparisonResult: null,
            templateUploadConfirmModalOpen: false,
            pendingTemplateFile: null,
            previousMonthInfo: null,
            errorMessage: null,
            errorDetails: null,
            SmartspotFinalReportModalOpen: false,
            SmartspotFinalReportInputFile: [],
            smartspotFileUpload: false,
            smartspotCurrentFile: {},
            smartspotFileName: '',
            phase2AutomationStatus: 'Pending',
            phase2Template1Status: 'Yet to Upload',
            phase2Template1Url: '',
            phase2Template2Status: 'Yet to Upload',
            phase2Template2Url: '',
            phase2OutputUrl: '',
            phase2ErrorMessage: null,
            // single Phase 2 template file
            phase2TemplateStatus: 'Yet to Upload',
            phase2TemplateUrl: '',
            // single tabbed conditions modal for all Phase 2 sheets
            phase2ConditionsModalOpen: false,
            phase2ConditionsActiveTab: 'nonAuditing',
            // phase 2 input file state
            phase2StandaloneReportStatus: 'Yet to Upload',
            phase2StandaloneReportUrl: '',
            phase2StandaloneReportFileUploaded: false,
            phase2StandaloneReportCurrentFile: {},
            phase2I100Status: 'Yet to Upload',
            phase2I100Url: '',
            phase2AdaptiveTTStatus: 'Yet to Upload',
            phase2AdaptiveTTUrl: '',
            phase2ChainMasterStatus: 'Yet to Upload',
            phase2ChainMasterUrl: '',
            phase2I100FileUploaded: false,
            phase2I100CurrentFile: {},
            // phase 2 template state — one set per template
            nonAuditingFileStatus: 'Yet to Upload',
            nonAuditingFileUrl: '',
            nonAuditingCol: [],
            nonAuditingColModal: false,
            nonAuditingComparisonResult: null,
            nonAuditingComparisonModalOpen: false,
            nonAuditingUploadConfirmModalOpen: false,
            nonAuditingPendingFile: null,
            nonAuditingPreviousMonthInfo: null,

            adaptiveTtFileStatus: 'Yet to Upload',
            adaptiveTtFileUrl: '',
            adaptiveTtCol: [],
            adaptiveTtColModal: false,
            adaptiveTtComparisonResult: null,
            adaptiveTtComparisonModalOpen: false,
            adaptiveTtUploadConfirmModalOpen: false,
            adaptiveTtPendingFile: null,
            adaptiveTtPreviousMonthInfo: null,

            adaptiveTotFileStatus: 'Yet to Upload',
            adaptiveTotFileUrl: '',
            adaptiveTotCol: [],
            adaptiveTotColModal: false,
            adaptiveTotComparisonResult: null,
            adaptiveTotComparisonModalOpen: false,
            adaptiveTotUploadConfirmModalOpen: false,
            adaptiveTotPendingFile: null,
            adaptiveTotPreviousMonthInfo: null,
            
            chainStoresFileStatus: 'Yet to Upload',
            chainStoresFileUrl: '',
            chainStoresCol: [],
            chainStoresColModal: false,
            chainStoresComparisonResult: null,
            chainStoresComparisonModalOpen: false,
            chainStoresUploadConfirmModalOpen: false,
            chainStoresPendingFile: null,
            chainStoresPreviousMonthInfo: null,
        };
    }

    async componentDidMount() {
        // If templateId is injected via props (from Automation.jsx parent),
        // skip internal template fetch and immediately load template data.
        if (this.props.templateId) {
            this._loadTemplateData(this.props.templateId);
        } else {
            await this.props.fetchTemplates({
                onSuccess: (res) => {
                    const last = res.templates[res.templates.length - 1];
                    this.setState(
                        { templates: res.templates, selectedTemplate: last.name, templateId: last._id, fileTemplates: last.fileTemplates },
                        () => this._loadTemplateData(last._id)
                    );
                },
                onFailure: () => {}
            });
        }
    }

    componentDidUpdate(prevProps) {
        // When the parent changes the template, reload all template-dependent data.
        if (this.props.templateId && this.props.templateId !== prevProps.templateId) {
            this._loadTemplateData(this.props.templateId);
        }
    }

    /**
     * Load all side-effect data that depends on a given templateId.
     * Called both on mount (props-driven) and when templateId prop changes.
     */
    _loadTemplateData = (templateId) => {
        clearTimeout(apiTimeout);
        // Local only: don't keep the previous month's Phase 2 status/URL
        // while this template's lookup is in flight.
        this.setState({
            phase2AutomationStatus: 'Pending',
            phase2OutputUrl: '',
            phase2ErrorMessage: null,
        });

        this.props.getWorkingFiles(templateId, this.state.disType, {
            onSuccess: (res) => {
                const workingFiles = res.workingFiles.filter(
                    d => d.fileType === 'Workings' || d.fileType === 'Smartspot Workings'
                );
                this.setState({ automationSplitFiles: res.workingFiles, workingFiles });
            },
            onFailure: () => {}
        });

        this.props.getSmartspotsplittedFiles(templateId, {
            onSuccess: (res) => {
                const hasFiles = res.auditingFiles.length > 0 && res.nonAuditingFiles.length > 0;
                this.setState({
                    auditingSplit: res.auditingFiles,
                    nonAuditingSplit: res.nonAuditingFiles,
                    splitBtn: !hasFiles,
                });
            },
            onFailure: () => {}
        });

        this.props.fetchAutomationStatusData(templateId, {
            onSuccess: (res) => {
                if (templateId !== this._templateId) return;
                if (res.automation_status && res.automation_status.length > 0) {
                    let standaloneOutputUrls = { physical_seller: '', seller: '' };
                    let standaloneStatusByType = { physical_seller: 'Pending', seller: 'Pending' };
                    let standaloneUpdatedAtByType = { physical_seller: null, seller: null };
                    let anyProcessing = false;
                    let anyFailed = false;
                    let anyCompleted = false;

                    res.automation_status.forEach((d) => {
                        if (d.file && d.disbursementType === 'Smartspot' && (d.file.startsWith('FinalOutput') || d.file === 'FinalOutput')) {
                            let typeKey = 'physical_seller';
                            if (d.file === 'FinalOutput_seller') {
                                typeKey = 'seller';
                            }
                            standaloneStatusByType[typeKey] = d.fileUploadStatus;
                            if (d.updatedAt) {
                                standaloneUpdatedAtByType[typeKey] = d.updatedAt;
                            }
                            if (d.fileUploadStatus === 'Completed') {
                                standaloneOutputUrls[typeKey] = d.finalOutputUrl || '';
                                anyCompleted = true;
                            } else if (d.fileUploadStatus === 'Processing') {
                                anyProcessing = true;
                            } else if (d.fileUploadStatus === 'Failed') {
                                anyFailed = true;
                            }
                        }
                    });

                    if (anyProcessing) {
                        this.setState({
                            automationStatus: 'Processing',
                            initial: false,
                            downloadEnable: false,
                            processingStartTime: null,
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                        clearTimeout(apiTimeout);
                        apiTimeout = setTimeout(this.loadData, 3000);
                    } else if (anyFailed) {
                        this.setState({
                            automationStatus: 'Failed',
                            initial: false,
                            downloadEnable: false,
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                        clearTimeout(apiTimeout);
                    } else if (anyCompleted) {
                        this.setState({
                            automationStatus: 'Completed',
                            initial: false,
                            downloadEnable: true,
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                        clearTimeout(apiTimeout);
                    } else {
                        this.setState({
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                    }
                } else {
                    this.setState({
                        outputUrl: '',
                        automationStatus: 'Pending',
                        initial: true,
                        downloadEnable: false,
                        standaloneOutputUrls: { physical_seller: '', seller: '' },
                        standaloneStatusByType: { physical_seller: 'Pending', seller: 'Pending' },
                        standaloneUpdatedAtByType: { physical_seller: null, seller: null }
                    });
                }
            },
            onFailure: () => {}
        });

        this.props.getSmartspotTemplateConditions(templateId, this._standaloneTemplateKey, {
            onSuccess: (res) => {
                if (!res.colConditions || res.colConditions.length === 0) {
                    this.cloneFromPreviousMonth(templateId);
                } else {
                    this.setState({ templateCol: res.colConditions });
                }
            },
            onFailure: () => { this.setState({ templateCol: [] }); }
        });

        SMARTSPOT_PHASE2_TEMPLATES.forEach((tmpl) => {
            this.props.getsmartspotTemplateConditions(templateId, tmpl.fileName, {
                onSuccess: (res) => {
                    this.setState({
                        [this._p2StateKey(tmpl.key, 'Col')]: (res.colConditions && res.colConditions.length > 0) ? res.colConditions : [],
                    });
                },
                onFailure: () => { this.setState({ [this._p2StateKey(tmpl.key, 'Col')]: [] }); }
            });
        });

        // Load mapping file status
        this.props.getSmartspotPlanData(templateId, {
            onSuccess: (res) => {
                const mappingFile = (res.files || []).find(f => f.fileName === 'smartspotMappingFile')
                this.setState({
                    mappingFileStatus: mappingFile ? 'Available' : 'Yet to Upload',
                    mappingFileUrl:    mappingFile ? mappingFile.result[0] : '',
                })
            },
            onFailure: () => {}
        });

        // Resume Phase 2 status polling if it was in progress
        this.props.fetchSmartspotFinalReportAutomationStatus(templateId, {
            onSuccess: (res) => {
                if (templateId !== this._templateId) return;
                if (res.fileUploadStatus === 'Completed') {
                    this.setState({ phase2AutomationStatus: 'Completed', phase2OutputUrl: res.finalOutputUrl, phase2ErrorMessage: null })
                } else if (res.fileUploadStatus === 'Processing') {
                    this.setState({ phase2AutomationStatus: 'Processing', phase2OutputUrl: '', phase2ErrorMessage: null })
                    clearTimeout(apiTimeout)
                    apiTimeout = setTimeout(this.loadPhase2StatusData, 3000)
                } else if (res.fileUploadStatus === 'Failed') {
                    this.setState({ phase2AutomationStatus: 'Failed', phase2ErrorMessage: res.errorMessage, phase2OutputUrl: '' })
                } else {
                    this.setState({ phase2AutomationStatus: 'Pending', phase2OutputUrl: '', phase2ErrorMessage: null })
                }
            },
            onFailure: () => {
                if (templateId !== this._templateId) return;
                this.setState({ phase2AutomationStatus: 'Pending', phase2OutputUrl: '', phase2ErrorMessage: null })
            }
        });
    }

    // ── Props-or-state helpers ────────────────────────────────────────────────
    // When the parent (Automation.jsx) injects these values via props we use props;
    // otherwise fall back to internal state so the component works standalone too.
    get _templateId()          { return this.props.templateId          || this.state.templateId }
    get _selectedTemplate()    { return this.props.selectedTemplate    || this.state.selectedTemplate }
    get _distributors()        { return this.props.distributors        || this.state.distributors }
    get _selectedDistributor() { return this.props.selectedDistributor || this.state.selectedDistributor }
    get _standaloneTemplateKey() {
        return this.state.auditType === 'Seller'
            ? 'smartspotStandaloneTemplateSeller'
            : 'smartspotStandaloneTemplate'
    }

    handleAuditTypeChange = (e, { value }) => {
        if (!value) return
        this.setState({
            auditType: value,
            templateStatus: 'Yet to Upload',
            templateDataUrl: '',
            templateCol: [],
            inputFileStatusList: []
        }, () => {
            this.loadStandaloneInputStatuses(value)
            this.loadTemplateConditionsForCurrentMode()
        })
    }

    loadTemplateConditionsForCurrentMode = () => {
        if (!this._templateId) return
        this.props.getSmartspotTemplateConditions(this._templateId, this._standaloneTemplateKey, {
            onSuccess: (res) => {
                if (!res.colConditions || res.colConditions.length === 0) {
                    this.cloneFromPreviousMonth(this._templateId)
                } else {
                    this.setState({ templateCol: res.colConditions })
                }
            },
            onFailure: () => { this.setState({ templateCol: [] }) }
        })
    }

    start = () => {
        if (!this._selectedTemplate) {
            alert('Please select a Template Month.')
            return
        }
        if (!this._selectedDistributor || this._selectedDistributor.length === 0) {
            alert('Please select a Distributor.')
            return
        }
        if (!this.state.auditType) {
            alert('Please select an Audit Type.')
            return
        }

        this.setState({
            automationStatus: 'Processing',
            initial: false
        })

        apiTimeout = setTimeout(this.loadData, 3000)

        let data = {
            templateId: this._templateId,
            distributorList: this._selectedDistributor,
            auditType: this.state.auditType
        }

        this.props.runSmartspotAutomationScript(data,{
            onSuccess: () => {

            },
            onFailure: (err) => {
                const msg = err?.response?.data?.error || 'Failed to start automation'
                alert(msg)
                this.setState({ automationStatus: 'Pending', initial: true })
                clearTimeout(apiTimeout)
            }
        })
    }

    startPhase2 = () => {
        if (!this._selectedTemplate) {
            alert('Please select a Template Month.')
            return
        }
        this.closePhase2Modal()
        this.setState({ phase2AutomationStatus: 'Processing', phase2ErrorMessage: null, phase2OutputUrl: '' })

        this.props.runSmartspotFinalReportAutomationScript(
            { templateId: this._templateId, distributorList: ['All'] },
            {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.loadPhase2StatusData, 3000)
                },
                onFailure: (err) => {
                    const msg = err?.response?.data?.error || 'Failed to start Phase 2 automation'
                    alert(msg)
                    this.setState({ phase2AutomationStatus: 'Pending' })
                }
            }
        )
    }

    loadPhase2StatusData = () => {
        const templateId = this._templateId
        this.props.fetchSmartspotFinalReportAutomationStatus(templateId, {
            onSuccess: (res) => {
                if (templateId !== this._templateId) return
                if (res.fileUploadStatus === 'Completed') {
                    this.setState({
                        phase2AutomationStatus: 'Completed',
                        phase2OutputUrl: res.finalOutputUrl,
                        phase2ErrorMessage: null,
                    })
                    clearTimeout(apiTimeout)
                } else if (res.fileUploadStatus === 'Failed') {
                    const errorMsg = res.errorMessage || 'Phase 2 automation failed.'
                    this.setState({
                        phase2AutomationStatus: 'Failed',
                        phase2ErrorMessage: errorMsg,
                    })
                    clearTimeout(apiTimeout)
                    alert(`Smartspot Phase 2 Failed!\n\n${errorMsg}`)
                } else if (res.fileUploadStatus !== 'Processing') {
                    this.setState({
                        phase2AutomationStatus: 'Pending',
                        phase2OutputUrl: '',
                        phase2ErrorMessage: null,
                    })
                    clearTimeout(apiTimeout)
                }
                // still Processing → keep polling
            },
            onFailure: () => {}
        })
        apiTimeout = setTimeout(this.loadPhase2StatusData, 3000)
    }

    restart = () => {
        if (!this._selectedDistributor || this._selectedDistributor.length === 0) {
            alert('Please select a Distributor.')
            this.setState({ restartConfirmOpen: false })
            return
        }
        if (!this.state.auditType) {
            alert('Please select an Audit Type.')
            this.setState({ restartConfirmOpen: false })
            return
        }

        const restartTime = new Date()
        this.setState({ restartConfirmOpen: false, automationStatus: 'Processing', initial: false, downloadEnable: false, processingStartTime: restartTime })
        apiTimeout = setTimeout(this.loadData, 3000)
        let data = {
            templateId: this._templateId,
            distributorList: this._selectedDistributor,
            auditType: this.state.auditType
        }
        this.props.runSmartspotAutomationScript(data, {
            onSuccess: () => {},
            onFailure: (err) => {
                const msg = err?.response?.data?.error || 'Failed to start automation'
                alert(msg)
                this.setState({ automationStatus: 'Completed', initial: false, downloadEnable: true })
                clearTimeout(apiTimeout)
            }
        })
    }

    openStandaloneModal = () => {
        if (!this._selectedTemplate) {
            alert('Please select a Template Month first.')
            return
        }
        if (!this._selectedDistributor || this._selectedDistributor.length === 0) {
            alert('Please select a Distributor.')
            return
        }
        this.setState({
            standaloneModalOpen: true,
            auditType: '',
            inputFileStatusList: [],
            templateStatus: 'Yet to Upload',
            templateDataUrl: '',
            templateCol: []
        })
    }

    closeStandaloneModal = () => {
        this.setState({ standaloneModalOpen: false, auditType: '' })
    }

    loadStandaloneInputStatuses = (auditTypeParam) => {
        const auditType = auditTypeParam || this.state.auditType
        const templateKey = auditType === 'Seller' ? 'smartspotStandaloneTemplateSeller' : 'smartspotStandaloneTemplate'
        this.loadInputFilesStatus(auditType)
        this.props.getSmartspotPlanData(this._templateId, {
            onSuccess: (res) => {
                const files = res.files || []
                const planFile = files.find(f => f.fileName === "smartspotStandalonePlanData")
                const templateFile = files.find(f => f.fileName === templateKey)
                this.setState({
                    planDataUrl: planFile ? planFile.result[0] : '',
                    planDataStatus: planFile ? 'Available' : 'Yet to Upload',
                    templateDataUrl: templateFile ? templateFile.result[0] : '',
                    templateStatus: templateFile ? 'Available' : 'Yet to Upload',
                })
            },
            onFailure: () => {}
        })
    }

    loadData = () => {
        this.props.fetchAutomationStatusData(this._templateId, {
            onSuccess: (res) => {
                if (res.automation_status && res.automation_status.length > 0) {
                    let standaloneOutputUrls = { ...this.state.standaloneOutputUrls };
                    let standaloneStatusByType = { ...this.state.standaloneStatusByType };
                    let standaloneUpdatedAtByType = { ...this.state.standaloneUpdatedAtByType };
                    let anyProcessing = false;
                    let anyFailed = false;
                    let anyCompleted = false;
                    let failedMsg = '';
                    let failedDetails = null;

                    res.automation_status.forEach((d) => {
                        if (d.file && d.disbursementType === 'Smartspot' && (d.file.startsWith('FinalOutput') || d.file === 'FinalOutput')) {
                            let typeKey = 'physical_seller';
                            if (d.file === 'FinalOutput_seller') {
                                typeKey = 'seller';
                            }
                            standaloneStatusByType[typeKey] = d.fileUploadStatus;
                            if (d.updatedAt) {
                                standaloneUpdatedAtByType[typeKey] = d.updatedAt;
                            }
                            if (d.fileUploadStatus === 'Completed') {
                                standaloneOutputUrls[typeKey] = d.finalOutputUrl || '';
                                anyCompleted = true;
                            } else if (d.fileUploadStatus === 'Processing') {
                                anyProcessing = true;
                            } else if (d.fileUploadStatus === 'Failed') {
                                anyFailed = true;
                                failedMsg = d.errorMessage || 'Automation failed. Please check the logs.';
                                failedDetails = d.errorDetails;
                            }
                        }
                    });

                    if (anyProcessing) {
                        this.setState({
                            automationStatus: 'Processing',
                            downloadEnable: false,
                            initial: false,
                            processingStartTime: null,
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                        clearTimeout(apiTimeout);
                        apiTimeout = setTimeout(this.loadData, 3000);
                    } else if (anyFailed) {
                        this.setState({
                            automationStatus: 'Failed',
                            downloadEnable: false,
                            initial: false,
                            processingStartTime: null,
                            errorMessage: failedMsg,
                            errorDetails: failedDetails,
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                        clearTimeout(apiTimeout);
                        alert(`Smartspot Automation Failed!\n\n${failedMsg}`);
                    } else if (anyCompleted) {
                        this.setState({
                            automationStatus: 'Completed',
                            downloadEnable: true,
                            initial: false,
                            processingStartTime: null,
                            errorMessage: null,
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                        clearTimeout(apiTimeout);
                    } else {
                        this.setState({
                            standaloneOutputUrls,
                            standaloneStatusByType,
                            standaloneUpdatedAtByType
                        });
                    }
                }
            },
            onFailure: () => {}
        });
    };

    smartspotSplitLoadData = () => {
        this.setState({loaderStatus:true})
        let data = {
            templateId:this._templateId,
            disType:this.state.disType
        }
        this.props.getSmartspotSplitStatus(this._templateId,{
            onSuccess:(res)=>{
                if (res.master.splitStatus == 'Completed') {
                    clearTimeout(apiTimeout)
                    this.props.updateSmartspotDistInfo(data,{
                    onSuccess:()=>{
                        this.setState({ loaderStatus:false })
                        this.props.getSmartspotsplittedFiles(this._templateId,
                            {
                            onSuccess:(res)=>{
                                if(res.auditingFiles.length > 0 && res.nonAuditingFiles.length > 0){
                                    this.setState({auditingSplit:res.auditingFiles,nonAuditingSplit:res.nonAuditingFiles,splitBtn:false})
                                }
                                else{
                                    this.setState({auditingSplit:res.auditingFiles,nonAuditingSplit:res.nonAuditingFiles,splitBtn:true})
                                }
                                
                            },
                            onFailure:()=>{
                            }
                        })
                    },
                    onFailure:()=>{

                    }
                })
                        
                }
            },
            onFailure:()=>{
                
            }
        })
        apiTimeout = setTimeout(this.smartspotSplitLoadData, 3000)
    };

    downloadfile = (url) => {
        window.open(url);
    };

    dropDownDistributorOnChange = (e, data) => {
        let filteredArray;
        if (data.value.includes('All') && data.value.length > 0) {
            filteredArray = data.value.filter((element) => element === 'All')
        } else {
            filteredArray = data.value.filter((element) => element !== 'All')
        }
        this.setState({ selectedDistributor: filteredArray })
    };

    dropDownTemplateOnChange = async(e, data) => {
        data.options.map((d)=>{
            if(d.value == data.value){
                this.setState({templateId:d.key})
                 this.props.fetchUseraction(
                    d.key,
                    {
                        onSuccess: (res) => {
                            let dis_list = []
                            if (res.users.length > 0) {
                                res.users.map((d) => {
                                    if (d.siteName && d.role == 'distributor') {
                                        dis_list.push({
                                            'key': d.siteName,
                                            'value': d.siteName,
                                            'text': d.siteName
                                        })
                                    }
                                })
                            }
                            dis_list.push({ 'key': 'All', 'value': 'All', 'text': 'All' })
                            this.setState({ distributors: dis_list })
                        },
                        onFailure: () => { this.setState({ loading: false }) }
                    });
                 this.props.getWorkingFiles(
                    d.key,this.state.disType,
                    {
                    onSuccess:(res)=>{
                        this.setState({automationSplitFiles:res.workingFiles})
                        let workingFiles = []
                        res.workingFiles.map((d)=>{
                            if(d.fileType == 'Workings'){
                                workingFiles.push(d)
                            }
                            else if(d.fileType == 'Smartspot Workings'){
                                workingFiles.push(d)
                            }
                        })
                        this.setState({workingFiles:workingFiles})
                    },
                    onFailure:()=>{
                    }
                })
                 this.props.getSmartspotsplittedFiles(d.key,
                    {
                    onSuccess:(res)=>{
                        if(res.auditingFiles.length > 0 && res.nonAuditingFiles.length > 0){
                            this.setState({auditingSplit:res.auditingFiles,nonAuditingSplit:res.nonAuditingFiles,splitBtn:false})
                        }
                        else{
                            this.setState({auditingSplit:res.auditingFiles,nonAuditingSplit:res.nonAuditingFiles,splitBtn:true})
                        }
                    },
                    onFailure:()=>{
                    }
                })

                this.props.fetchAutomationStatusData(
                    d.key,
                    {
                    onSuccess: (res) => {
                        if (res.automation_status && res.automation_status.length > 0) {
                            let standaloneOutputUrls = { physical_seller: '', seller: '' };
                            let standaloneStatusByType = { physical_seller: 'Pending', seller: 'Pending' };
                            let standaloneUpdatedAtByType = { physical_seller: null, seller: null };
                            let anyProcessing = false;
                            let anyFailed = false;
                            let anyCompleted = false;

                            res.automation_status.forEach((d) => {
                                if (d.file && d.disbursementType === 'Smartspot' && (d.file.startsWith('FinalOutput') || d.file === 'FinalOutput')) {
                                    let typeKey = 'physical_seller';
                                    if (d.file === 'FinalOutput_seller') {
                                        typeKey = 'seller';
                                    }
                                    standaloneStatusByType[typeKey] = d.fileUploadStatus;
                                    if (d.updatedAt) {
                                        standaloneUpdatedAtByType[typeKey] = d.updatedAt;
                                    }
                                    if (d.fileUploadStatus === 'Completed') {
                                        standaloneOutputUrls[typeKey] = d.finalOutputUrl || '';
                                        anyCompleted = true;
                                    } else if (d.fileUploadStatus === 'Processing') {
                                        anyProcessing = true;
                                    } else if (d.fileUploadStatus === 'Failed') {
                                        anyFailed = true;
                                    }
                                }
                            });

                            if (anyProcessing) {
                                this.setState({
                                    automationStatus: 'Processing',
                                    initial: false,
                                    downloadEnable: false,
                                    processingStartTime: null,
                                    standaloneOutputUrls,
                                    standaloneStatusByType,
                                    standaloneUpdatedAtByType
                                });
                                clearTimeout(apiTimeout);
                                apiTimeout = setTimeout(this.loadData, 3000);
                            } else if (anyFailed) {
                                this.setState({
                                    automationStatus: 'Failed',
                                    initial: false,
                                    downloadEnable: false,
                                    standaloneOutputUrls,
                                    standaloneStatusByType,
                                    standaloneUpdatedAtByType
                                });
                                clearTimeout(apiTimeout);
                            } else if (anyCompleted) {
                                this.setState({
                                    automationStatus: 'Completed',
                                    initial: false,
                                    downloadEnable: true,
                                    standaloneOutputUrls,
                                    standaloneStatusByType,
                                    standaloneUpdatedAtByType
                                });
                                clearTimeout(apiTimeout);
                            } else {
                                this.setState({
                                    standaloneOutputUrls,
                                    standaloneStatusByType,
                                    standaloneUpdatedAtByType
                                });
                            }
                        } else {
                            this.setState({
                                outputUrl: '',
                                automationStatus: 'Pending',
                                initial: true,
                                downloadEnable: false,
                                standaloneOutputUrls: { physical_seller: '', seller: '' },
                                standaloneStatusByType: { physical_seller: 'Pending', seller: 'Pending' },
                                standaloneUpdatedAtByType: { physical_seller: null, seller: null }
                            });
                        }
                    },
                    onFailure: () => {

                    }
                })

                this.props.getSmartspotTemplateConditions(
                    d.key,
                    this._standaloneTemplateKey,
                    {
                        onSuccess: (res) => {
                            if(!res.colConditions || res.colConditions.length === 0) {
                                this.cloneFromPreviousMonth(d.key)
                            } else {
                                this.setState({templateCol : res.colConditions})
                            }
                        },
                        onFailure: () => { this.setState({ templateCol: [] }) }
                    }
                )

                // Restore phase 2 template conditions for all phase2 templates
                SMARTSPOT_PHASE2_TEMPLATES.forEach((tmpl) => {
                    this.props.getsmartspotTemplateConditions(
                        d.key,
                        tmpl.fileName,
                        {
                            onSuccess: (res) => {
                                if (res.colConditions && res.colConditions.length > 0) {
                                    this.setState({ [this._p2StateKey(tmpl.key, 'Col')]: res.colConditions })
                                } else {
                                    this.setState({ [this._p2StateKey(tmpl.key, 'Col')]: [] })
                                }
                            },
                            onFailure: () => { this.setState({ [this._p2StateKey(tmpl.key, 'Col')]: [] }) }
                        }
                    )
                })
            }
        })
        this.setState({ selectedTemplate: data.value })
    };

    closeFormulaModal = () => {
        this.setState({ 
            formulaModalOpen: false,
            templateColModal: false,
            templateUploadConfirmModalOpen: false,
            templateComparisonModalOpen: false
        })
    };

    formulasModal = (types) => {
        if(types == 'Main'){
            this.props.getDisbursementFormulas({
                onSuccess: (res) => {
                    let formulas_calc = res.data.formulas.slice(2, -2)
                    this.setState({ formulas: formulas_calc })
                },
                onFailure: () => {
    
                }
            })
            this.setState({formulasType: types,formulaModalOpen: true })
        }

        else {
            let data = {
                type:types
            }
            this.props.getSplitFilesFormulas(data,{
                onSuccess: (res) => {
                    let formulas_calc = res.formulas
                    this.setState({ formulas: formulas_calc })
                },
                onFailure: () => {
    
                }
            })
            this.setState({formulasType: types,formulaModalOpen: true })

        }
        
       
    };

    formulaOnChange = (e, data) => {
        let formulas_data = this.state.formulas;
        formulas_data.map((d) => {
            if (Object.keys(d)[0] == Object.keys(data)[0]) {
                d[Object.keys(d)[0]] = e.target.value + '\n'
            }
        })
        this.setState({ formulas: formulas_data })
    };

    saveFormulas = () => {
        let data = {
            formulas: this.state.formulas
        }
        let split_data = {
            formulas: this.state.formulas,
            type:this.state.formulasType
        }
        if(this.state.formulasType == 'Main'){
            this.props.updateDisbursementFormulas(data, {
                onSuccess: () => {
                    this.setState({ formulaModalOpen: false })
                    alert("Formulas File Updated")
                },
                onFailure: () => {
    
                }
            })
        }
        else{
            this.props.updateSplitFileFormulas(split_data, {
                onSuccess: () => {
                    this.setState({ formulaModalOpen: false })
                    alert("Formulas File Updated")
                },
                onFailure: () => {
    
                }
            })
        }
        
    };

    closeuploadoption = () =>{
        this.setState({modalOpen:false})
    };

    fileupload = (file) => {
        const uploadedFile = file.target.files[0]
        if (['smartspotStandaloneTemplate', 'smartspotStandaloneTemplateSeller'].includes(this.state.fileName) && this._templateId){
            this.checkPreviousConditionsBeforeUpload(uploadedFile)
        } else {
            this.setState({currentFile: uploadedFile, fileUploaded: true})
        }
    };

    uploadRawFile = () => {
        this.setState({loaderStatus:true})
        this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this._templateId, {
            onSuccess: () => {
                this.setState({ modalOpen: false,loaderStatus:false })
                alert("File Uploaded Successfully")

                // Refresh working files
                this.props.getWorkingFiles(
                    this._templateId,this.state.disType,
                    {
                    onSuccess:(res)=>{
                        this.setState({automationSplitFiles:res.workingFiles})
                        let workingFiles = []
                        res.workingFiles.map((d)=>{
                            if(d.fileType == 'Workings'){
                                workingFiles.push(d)
                            }
                            else if(d.fileType == 'Smartspot Workings'){
                                workingFiles.push(d)
                            }
                        })
                        this.setState({workingFiles:workingFiles})
                    },
                    onFailure:()=>{
                    }
                })


                // Refresh input files list if it's an input file
                const inputFileNames = [
                    "Minimarket - Final Master",
                    "PSR Target",
                    "Channel 1 Target",
                    "SGF Fixed rack rate",
                    "Audit Summary File",
                    "P&G Target",
                    "Smartspot DGP Archivement",
                    "Channel List"
                ]
                if (inputFileNames.includes(this.state.fileName)) {
                    this.loadInputFilesStatus(this.state.auditType)
                }

                // Refresh plan data if it's plan data file
                if (this.state.fileName === 'smartspotStandalonePlanData') {
                    this.props.getSmartspotPlanData(this._templateId, {
                        onSuccess: (res) => {
                            const planFile = res.files.find(f => f.fileName === "smartspotStandalonePlanData")
                            this.setState({
                                planDataUrl: planFile ? planFile.result[0] : '',
                                planDataStatus: planFile ? 'Available' : 'Yet to Upload'
                            })
                        }
                    })
                }

                // Refresh template if it's template file
                if (['smartspotStandaloneTemplate', 'smartspotStandaloneTemplateSeller'].includes(this.state.fileName)) {
                    this.props.getSmartspotPlanData(this._templateId, {
                        onSuccess: (res) => {
                            const templateFile = res.files.find(f => f.fileName === this.state.fileName)
                            this.setState({
                                templateDataUrl: templateFile ? templateFile.result[0] : '',
                                templateStatus: templateFile ? 'Available' : 'Yet to Upload'
                            })
                            // trigger comparison after template upload
                            this.handleTemplateComparison()
                        }
                    })
                }

                // // smartspot mapping file
                // if (this.state.fileName === 'smartspotMappingFile') {
                //     this.props.get
                // }
            },
            onFailure: () => {
                this.setState({ modalOpen: false, loaderStatus: false })
                alert(`${this.state.fileName} - File Upload Failed.`)
            }
        })
    };

    uploadFile = async (fileName, type) => {
        console.log(type,'type')
        this.setState({ fileName: fileName, fileType: type,modalOpen:true })
        
    };

    splitFiles = async()=>{
        if(this.state.splitBtn == true){
            let data ={
                templateId:this._templateId,
                disType:this.state.disType
            }
            this.setState({loaderStatus:true})
            await this.props.splitSmartspotfiles(data,{
                onSuccess:()=>{
                    apiTimeout = setTimeout(this.smartspotSplitLoadData, 3000)  
                }
            })
        }
        else{
            alert('Split Already Done')
        }
    };

    processApprovedFiles = () =>{
        let templateId = this._templateId
        this.setState({loaderStatus:true})
        this.props.processApprovedFiles(templateId,{
            onSuccess:()=>{
                this.setState({loaderStatus:false})
            },
            onFailure:()=>{

            }
        })
    };

    siteData = (rowData, checkedValue) => {
        console.log(rowData,'rowData')
        this.setState({'selectedDist':rowData})
        
    };

    sendedData = (rowData, row) => {
        this.setState({'selectedDist':rowData})
    };

    releaseWorking = () =>{
        if(this.state.selectedDist.length !== 0){
            const isValid = this.state.selectedDist.every(item => item.dseClientUpdate === 'Completed')
            if(isValid == true){
                this.props.smartspotSendWorkingFiles(this.state.selectedDist,{
                    onSuccess:()=>{
                        alert('Working Files Released Successfully')
                    },
                    onFailure:()=>{
                        
                    }
                })
            }else{
                alert('Selected Sites Still Not Uploaded DSE Files')
            }
        }
        else{
            alert('Please Select Distributor')
        }
        
    };

    processCreditNotes = () =>{
        if(this.state.selectedDist.length !== 0){
            if(this.state.selectedDist.length == 1){
                if(this.state.selectedDist[0].dseClientUpdate != 'pending'){
                    this.setState({loaderStatus:true})
                    this.props.processSmartspotCreditNote(this.state.selectedDist,{
                        onSuccess:()=>{
                            this.setState({loaderStatus:false})
                            alert('Credit Note Process Done')
                        },
                        onFailure:()=>{
                        }
                    })
                }
                else{
                    alert("DSE File Process Not Yet Done")
                }
            }
            else{
                alert("Can't Select more than one distributors")
            }
        }

            
        else{
            alert('Please Select Distributor')
        }
    };

    releaseCreditNote =()=>{
        if(this.state.selectedDist.length !== 0){
            const isValid = this.state.selectedDist.every(item => item.creditNoteStatus === 'Completed')
            if(isValid == true){
                this.props.sendSmartspotCreditNoteFiles(this.state.selectedDist,{
                    onSuccess:()=>{
                        alert('Working Files Released Successfully')
                    },
                    onFailure:()=>{
        
                    }
                })
            }else{
                alert('Selected Sites Still Not Uploaded DSE Files')
            }
        }
        else{
            alert('Please Select Distributor')
        }
        
    };

    loadInputFilesStatus = (auditTypeParam) => {
        if (!this._selectedTemplate) {
            alert('Month template - Not selected.')
            return
        }

        const auditType = auditTypeParam || this.state.auditType;
        this.props.checkSmartspotInputData(
            this._templateId,
            auditType,
            {
                onSuccess: (res) => {
                    this.setState({ inputFileStatusList: res.status_list })
                },
                onFailure: () => {}
            }
        )
    };

    uploadInputFile = (file, fileName) => {
        this.setState({
            loaderStatus: true,
            uploadingFileName: fileName
        })
        this.props.rawFileProcess(
            file,
            fileName,
            this._templateId, 
            {
                onSuccess: () => {
                    this.setState({
                        loaderStatus: false,
                        uploadingFileName: null,
                    })
                    this.loadInputFilesStatus()
                },
                onFailure: () => {
                    this.setState({
                        loaderStatus: false,
                        uploadingFileName: null
                    })
                    alert(`${fileName} - File Upload Failed.`)
                }
            }
        )
    };

    downloadInputFile = (url) => {
        window.open(url)
    };

    uploadMappingFile = () => {
        if (!this.state.mappingFileUploaded) return
        this.setState({ loaderStatus: true })
        this.props.rawFileProcess(
            this.state.mappingCurrentFile,
            'smartspotMappingFile',
            this._templateId,
            {
                onSuccess: () => {
                    this.setState({
                        loaderStatus: false,
                        mappingFileUploaded: false,
                        mappingCurrentFile: {},
                    })
                    alert('Smartspot Mapping File uploaded successfully')
                    this.loadPhase2InputStatuses()
                },
                onFailure: () => {
                    this.setState({ loaderStatus: false })
                    alert('Smartspot Mapping File upload failed.')
                }
            }
        )
    }

    openMappingFileModal = () => {
        this.setState({ mappingFileModalOpen: true })
    }

    openPlanDataModel = () => {
        if (!this._selectedTemplate){
            alert('Month template - Not selected.')
            return
        }
        this.props.getSmartspotPlanData(this._templateId, {
            onSuccess: (res) => {
                const planFile = res.files.find(f => f.fileName === "smartspotStandalonePlanData")
                this.setState({
                    planDataUrl: planFile ? planFile.result[0] : '',
                    planDataStatus: planFile ? 'Available' : 'Yet to Upload',
                    planDataModalOpen: true
                })
            },
            onFailure: () => {
                this.setState({ planDataModalOpen: true })
            }
        })
    };

    openTemplateModel = () => {
        this.props.getSmartspotPlanData(
            this._templateId,
            {
                onSuccess: (res) => {
                    const templateFile = res.files.find(f => f.fileName === this._standaloneTemplateKey)
                    this.setState({
                        templateDataUrl: templateFile ?
                        templateFile.result[0] : '',
                        templateStatus: templateFile ?
                        'Available' : 'Yet to Upload',
                        templateModalOpen: true
                    })
                },
                onFailure: () => {
                    this.setState({ templateModalOpen: true })
                }
            }
        )
    };

    cloneFromPreviousMonth = (templateId) => {
        // 1. check template file exists
        this.props.getSmartspotPlanData(
            templateId,
            {
                onSuccess: (planRes) => {
                    const templateFile = planRes.files.find(f => f.fileName === this._standaloneTemplateKey)
                    if (!templateFile) { this.setState({ templateCol: [] }); return }
                    // 2. Get previous month
                    this.props.getSmartspotPreviousMonthTemplate(
                        templateId,
                        this._standaloneTemplateKey,
                        {
                            onSuccess: (prevRes) => {
                                if (!prevRes.previousTemplateId) { this.setState({ templateCol: [] }); return }
                                //3. compare & clone
                                this.props.compareSmartspotTemplateColumns(
                                    {
                                        templateId,
                                        copyFromTemplateId: prevRes.previousTemplateId,
                                        templateKey: this._standaloneTemplateKey,
                                        sourceTemplateKey: this._standaloneTemplateKey
                                    },
                                    {
                                        onSuccess: (compareRes) => {
                                            if (compareRes.hasExistingConditions && compareRes.preservableCount > 0) {
                                                this.setState({ templateCol: compareRes.preservableConditions })
                                            } else {
                                                this.setState({ templateCol: [] })
                                            }
                                        },
                                        onFailure: () => { this.setState({ templateCol: [] }) }
                                    }
                                )
                            },
                            onFailure: () => { this.setState({ templateCol: [] }) }

                        }
                    )
                },
                onFailure: () => { this.setState({ templateCol: [] }) }
            }
        )
    };

    cloneFromPhysicalSeller = () => {
        if (!this._templateId) {
            alert('Please select a Month template first.')
            return
        }
        if (!window.confirm('Clone matching column conditions from Physical + Seller into the Seller template? Existing Seller mappings for matching columns will be overwritten.')) {
            return
        }
        // First verify physical + seller template exists / has conditions
        this.props.getSmartspotTemplateConditions(
            this._templateId,
            'smartspotStandaloneTemplate',
            {
                onSuccess: (res) => {
                    if (!res.colConditions || res.colConditions.length === 0) {
                        alert('Physical + Seller template has no saved conditions to clone from.')
                        return
                    }
                    // Compare & clone from Physical+Seller into Seller
                    this.props.compareSmartspotTemplateColumns(
                        {
                            templateId: this._templateId,
                            copyFromTemplateId: this._templateId,
                            templateKey: 'smartspotStandaloneTemplateSeller',
                            sourceTemplateKey: 'smartspotStandaloneTemplate'
                        },
                        {
                            onSuccess: (compareRes) => {
                                if (compareRes.hasExistingConditions && compareRes.preservableCount > 0) {
                                    this.setState({
                                        templateCol: compareRes.preservableConditions,
                                        templateComparisonModalOpen: !compareRes.columnsMatch,
                                        comparisonResult: compareRes
                                    })
                                    if (compareRes.columnsMatch) {
                                        alert(`✅ Cloned ${compareRes.preservableConditions.length} conditions from Physical + Seller.`)
                                    }
                                } else {
                                    alert('⚠️ No matching columns found between Physical + Seller and Seller templates.')
                                }
                            },
                            onFailure: () => {
                                alert('Failed to clone conditions from Physical + Seller.')
                            }
                        }
                    )
                },
                onFailure: () => {
                    alert('Failed to retrieve Physical + Seller conditions.')
                }
            }
        )
    };

    checkPreviousConditionsBeforeUpload = (uploadFile) => {
        this.props.getSmartspotPreviousMonthTemplate(
            this._templateId,
            this._standaloneTemplateKey,
            {
                onSuccess: (prevRes) => {
                    const hasPrev = prevRes.previousTemplateId !== null
                    const hasCurrent = this.state.templateCol && this.state.templateCol.length > 0
                    if (hasPrev || hasCurrent) {
                        this.setState({
                            pendingTemplateFile: uploadFile,
                            previousMonthInfo: prevRes,
                            templateUploadConfirmModalOpen: true,
                            fileUploaded: false
                        })
                    } else {
                        this.setState({ currentFile: uploadFile, fileUploaded: true })
                    }
                },
                onFailure: () => { this.setState({ currentFile: uploadFile, fileUploaded: true }) }
            }
        )
    };

    confirmTemplateUpload = () => {
        this.setState({
            currentFile: this.state.pendingTemplateFile,
            fileUploaded: true,
            templateUploadConfirmModalOpen: false,
            pendingTemplateFile: null
        })
    };

    cancelTemplateUpload = () => {
        this.setState({
            templateUploadConfirmModalOpen: false,
            pendingTemplateFile: null,
            modalOpen: false
        })
    };

    handleTemplateComparison = () => {
        this.props.getSmartspotPreviousMonthTemplate(
            this._templateId,
            this._standaloneTemplateKey,
            {
                onSuccess: (prevRes) => {
                    this.compareAndApplyConditions({
                        templateId: this._templateId,
                        copyFromTemplateId: prevRes.previousTemplateId || null,
                        templateKey: this._standaloneTemplateKey,
                        sourceTemplateKey: this._standaloneTemplateKey
                    }, prevRes.previousTemplateName)
                },
                onFailure: () => {
                    this.compareAndApplyConditions({
                        templateId: this._templateId,
                        templateKey: this._standaloneTemplateKey,
                        sourceTemplateKey: this._standaloneTemplateKey
                    }, null)
                }
            }
        )
    };

    compareAndApplyConditions = (data, previousMonthName) => {
        this.props.compareSmartspotTemplateColumns(
            data, {
                onSuccess: (res) => {
                    if (!res.hasExistingConditions) {
                        this.setState({ templateCol: [] });
                        return
                    }
                    if (res.columnsMatch) {
                        this.setState({ templateCol: res.preservableConditions })
                        alert(`Template uploaded!\n\n✅ All ${res.preservableConditions.length} conditions preserved.`)
                    } else if (res.preservableCount > 0) {
                        this.setState({
                            templateCol: res.preservableConditions,
                            templateComparisonModalOpen: true,
                            comparisonResult: res
                        })
                    } else {
                        this.setState({ templateCol: [] })
                        alert(`Template uploaded!\n\n⚠️ New template has different columns. All conditions cleared.`)
                    }
                },
                onFailure: () => { this.setState({ templateCol: [] }) }
            }
        )
    };

    applySmartspotConditions = () => {
        if (!this._templateId) { alert("please select a template Month."); return }
        if (this.state.templateCol.length === 0) {
            this.props.extractSmartspotTemplateCol(
                this._templateId,
                this._standaloneTemplateKey,
                {
                    onSuccess: (res) => {
                        if (res.result && res.result.length) {
                            this.setState({
                                templateCol: res.result,
                                templateColModal: true
                            })
                        } else {
                            alert('Please upload the Template File.')
                        }
                    },
                    onFailure: () => { alert('Please upload the Template File.') }
                }
            )
        } else {
            this.setState({ templateColModal: true })
        }
    };

    dropDownColOnChange = (e, data) => {
        const templateCol = this.state.templateCol.map((col) => {
            if (col.colName === data.additionLabel) {
                return { ...col, fileType: data.value }
            }
            return col
        })
        this.setState({ templateCol })
    };

    fileColOnChange = (e, data) => {
        const templateCol = this.state.templateCol.map((col) => {
            if (col.colName === data.colName) {
                return { ...col, colNum: e.target.value }
            }
            return col
        })
        this.setState({ templateCol })
    };

    saveFileColTemplate = () => {
        // Validate before saving
        const errors = this.validateColumnConditions();

        if (errors.length > 0) {
            const errorMessage = errors.map(e => `${e.colName}: ${e.message}`).join('\n');
            alert(`Validation Errors:\n\n${errorMessage}`);
            return;
        }

        let data = {
            colConditions: this.state.templateCol,
            templateId: this._templateId,
            templateKey: this._standaloneTemplateKey
        }

        this.props.saveSmartspotTemplateCol(
            data, {
                onSuccess: () => {
                    this.setState({ templateColModal: false });
                    alert("Conditions saved successfully");
                },
                onFailure: () => {
                    alert("Failed to save conditions");
                }
            }
        )
    };

    _splitPrimaryFallback = (value) => {
        const text = (value || '').trim();
        if (!text.includes('||')) return { primary: text, fallback: '' };
        const parts = text.split('||');
        const primary = (parts[0] || '').trim();
        const fallback = parts.slice(1).join('||').trim();
        return { primary, fallback };
    };

    _countSlashInputs = (value) => {
        return (value || '')
            .split('/')
            .map((s) => s.trim())
            .filter((s) => s)
            .length;
    };

    _validateMappingRow = (col) => {
        const errors = [];
        if (!col.fileType || !col.colNum) return errors;
        if (col.fileType.trim() === 'Formula') return errors;

        const fileTokens = this._splitPrimaryFallback(col.fileType);
        const colTokens = this._splitPrimaryFallback(col.colNum);

        const hasFileFallback = Boolean(fileTokens.fallback);
        const hasColFallback = Boolean(colTokens.fallback);

        if (hasFileFallback !== hasColFallback) {
            errors.push({
                colName: col.colName,
                message: 'When using fallback mapping, both File Type and Column Number must include "||".'
            });
            return errors;
        }

        const primaryFileCount = this._countSlashInputs(fileTokens.primary);
        const primaryColCount = this._countSlashInputs(colTokens.primary);
        if (primaryFileCount !== primaryColCount) {
            errors.push({
                colName: col.colName,
                message: `Primary mapping mismatch: File Type has ${primaryFileCount} input(s) but Column Number has ${primaryColCount} input(s)`
            });
        }

        if (hasFileFallback) {
            const fallbackFileCount = this._countSlashInputs(fileTokens.fallback);
            const fallbackColCount = this._countSlashInputs(colTokens.fallback);
            if (fallbackFileCount !== fallbackColCount) {
                errors.push({
                    colName: col.colName,
                    message: `Fallback mapping mismatch: File Type has ${fallbackFileCount} input(s) but Column Number has ${fallbackColCount} input(s)`
                });
            }
        }

        return errors;
    };
    
    validateColumnConditions = () => {
        const errors = [];
        
        for (const col of this.state.templateCol) {
            errors.push(...this._validateMappingRow(col));
        }
        
        return errors;
    };

    // smartspot phase 2
    openPhase2Modal = () => {
        if (!this._selectedTemplate) {
            alert('Please select a Template Month first.')
            return
        }
        // Standalone process must complete before phase 2 can be opened
        if (this.state.automationStatus !== 'Completed') {
            alert('Standalone Disbursement Processing must be completed before opening Smartspot Automation.')
            return
        }
        this.setState({ SmartspotFinalReportModalOpen: true })
        this.loadPhase2InputStatuses()
    }

    closePhase2Modal = () => {
        this.setState({ SmartspotFinalReportModalOpen: false })
    }

    loadPhase2InputStatuses = () => {
        // Load the single Phase 2 template file status + URL
        this.props.getSmartspotPlanData(this._templateId, {
            onSuccess: (res) => {
                const phase2Tmpl = res.files.find(f => f.fileName === PHASE2_TEMPLATE_FILE_NAME)
                const tmplAvailable = phase2Tmpl ? 'Available' : 'Yet to Upload'
                const tmplUrl = phase2Tmpl ? phase2Tmpl.result[0] : ''
                // All 4 sheet types share the same file — set the same status/url for each
                const mappingFile = res.files.find(f => f.fileName === 'smartspotMappingFile')
                this.setState({
                    nonAuditingFileStatus: tmplAvailable,
                    nonAuditingFileUrl: tmplUrl,
                    adaptiveTtFileStatus: tmplAvailable,
                    adaptiveTtFileUrl: tmplUrl,
                    adaptiveTotFileStatus: tmplAvailable,
                    adaptiveTotFileUrl: tmplUrl,
                    chainStoresFileStatus: tmplAvailable,
                    chainStoresFileUrl: tmplUrl,
                    phase2TemplateUrl: tmplUrl,
                    phase2TemplateStatus: tmplAvailable,
                    mappingFileStatus: mappingFile ? 'Available' : 'Yet to Upload',
                    mappingFileUrl:    mappingFile ? mappingFile.result[0] : '',
                })
            },
            onFailure: () => {}
        })
        this.props.checkSmartspotFinalReportInputs(this._templateId, {
            onSuccess: (res) => {
                const find = (name) => res.status_list.find(f => f.fileName === name)
                const standalone = find('Standalone Report')
                const i100 = find('i-100 File')
                const adaptiveTT = find('Adaptive Trade Terms')
                const chainMaster = find('Chain Master')
                this.setState({
                    phase2StandaloneReportStatus: standalone ? standalone.status : 'Yet to Upload',
                    phase2StandaloneReportUrl:    standalone ? standalone.downloadUrl : '',
                    phase2I100Status:             i100 ? i100.status : 'Yet to Upload',
                    phase2I100Url:                i100 ? i100.downloadUrl : '',
                    phase2AdaptiveTTStatus:       adaptiveTT ? adaptiveTT.status : 'Not Available',
                    phase2AdaptiveTTUrl:          adaptiveTT ? adaptiveTT.downloadUrl : '',
                    phase2ChainMasterStatus:      chainMaster ? chainMaster.status : 'Not Available',
                    phase2ChainMasterUrl:         chainMaster ? chainMaster.downloadUrl : '',
                })
            },
            onFailure: () => {}
        })
        // Restore saved colConditions for each sheet from the single template record
        SMARTSPOT_PHASE2_TEMPLATES.forEach((tmpl) => {
            this.props.getsmartspotTemplateConditions(
                this._templateId,
                tmpl.sheetName,    // use sheetName as the DB key
                {
                    onSuccess: (res) => {
                        if (res.colConditions && res.colConditions.length > 0) {
                            this.setState({ [this._p2StateKey(tmpl.key, 'Col')]: res.colConditions })
                        }
                    },
                    onFailure: () => {}
                }
            )
        })
    }

    uploadPhase2I100 = () => {
        if (!this.state.phase2I100FileUploaded) return
        this.setState({ loaderStatus: true })
        this.props.rawFileProcess(
            this.state.phase2I100CurrentFile,
            'smartspotI100',
            this._templateId,
            {
                onSuccess: () => {
                    this.setState({
                        loaderStatus: false,
                        phase2I100Status: 'Available',
                        phase2I100FileUploaded: false,
                        phase2I100CurrentFile: {},
                    })
                    alert('i-100 File Uploaded Successfully')
                    this.loadPhase2InputStatuses()
                },
                onFailure: () => {
                    this.setState({ loaderStatus: false })
                    alert('i-100 File Upload Failed.')
                }
            }
        )
    }

    uploadPhase2StandaloneReport = () => {
        if (!this.state.phase2StandaloneReportFileUploaded) return
        this.setState({ loaderStatus: true })
        this.props.rawFileProcess(
            this.state.phase2StandaloneReportCurrentFile,
            'smartspotStandaloneReportInput',
            this._templateId,
            {
                onSuccess: () => {
                    this.setState({
                        loaderStatus: false,
                        phase2StandaloneReportStatus: 'Available',
                        phase2StandaloneReportFileUploaded: false,
                        phase2StandaloneReportCurrentFile: {},
                    })
                    alert('Standalone Report Uploaded Successfully')
                    this.loadPhase2InputStatuses()
                },
                onFailure: () => {
                    this.setState({ loaderStatus: false })
                    alert('Standalone Report Upload Failed.')
                }
            }
        )
    }

    // ── Phase 2 template helpers — scoped per template key ──────────────────

    // Returns the camelCase state prefix for any template key defined in SMARTSPOT_PHASE2_TEMPLATES
    // e.g. 'nonAuditing' -> 'nonAuditingCol', 'adaptiveTot' -> 'adaptiveTotCol'
    _p2StateKey = (key, field) => `${key}${field}`

    checkP2TemplatePreviousConditions = (key, uploadFile) => {
        this.props.getSmartspotPreviousMonthTemplate(this._templateId, {
            onSuccess: (prevRes) => {
                const hasPrev = prevRes.previousTemplateId !== null
                const hasCurrent = (this.state[this._p2StateKey(key, 'Col')] || []).length > 0
                if (hasPrev || hasCurrent) {
                    this.setState({
                        [this._p2StateKey(key, 'PendingFile')]: uploadFile,
                        [this._p2StateKey(key, 'PreviousMonthInfo')]: prevRes,
                        [this._p2StateKey(key, 'UploadConfirmModalOpen')]: true,
                    })
                } else {
                    this.uploadP2TemplateFile(key, uploadFile)
                }
            },
            onFailure: () => { this.uploadP2TemplateFile(key, uploadFile) }
        })
    }

    confirmP2TemplateUpload = (key) => {
        const pendingFile = this.state[this._p2StateKey(key, 'PendingFile')]
        this.setState({
            [this._p2StateKey(key, 'UploadConfirmModalOpen')]: false,
            [this._p2StateKey(key, 'PendingFile')]: null,
        }, () => this.uploadP2TemplateFile(key, pendingFile))
    }

    cancelP2TemplateUpload = (key) => {
        this.setState({
            [this._p2StateKey(key, 'UploadConfirmModalOpen')]: false,
            [this._p2StateKey(key, 'PendingFile')]: null,
        })
    }

    uploadP2TemplateFile = (key, file) => {
        // All phase 2 sheets share the single template file
        this.setState({ loaderStatus: true })
        this.props.rawFileProcess(file, PHASE2_TEMPLATE_FILE_NAME, this._templateId, {
            onSuccess: () => {
                this.setState({
                    loaderStatus: false,
                    phase2TemplateStatus: 'Available',
                    // mark all sheets as Available since they share one file
                    nonAuditingFileStatus: 'Available',
                    adaptiveTtFileStatus: 'Available',
                    adaptiveTotFileStatus: 'Available',
                    chainStoresFileStatus: 'Available',
                })
                alert('Phase 2 template uploaded successfully')
                this.loadPhase2InputStatuses()
                // Run comparison for all 4 sheets — single file covers all of them
                SMARTSPOT_PHASE2_TEMPLATES.forEach((tmpl) => {
                    this.handleP2TemplateComparison(tmpl.key)
                })
            },
            onFailure: () => {
                this.setState({ loaderStatus: false })
                alert('Phase 2 template upload failed.')
            }
        })
    }

    handleP2TemplateComparison = (key) => {
        const tmpl = SMARTSPOT_PHASE2_TEMPLATES.find(t => t.key === key)
        const sheetName = tmpl ? tmpl.sheetName : key
        this.props.getSmartspotPreviousMonthTemplate(this._templateId, {
            onSuccess: (prevRes) => {
                this.compareAndApplyP2Conditions(key, {
                    templateId: this._templateId,
                    copyFromTemplateId: prevRes.previousTemplateId || null,
                    templateKey: sheetName
                })
            },
            onFailure: () => {
                this.compareAndApplyP2Conditions(key, {
                    templateId: this._templateId,
                    templateKey: sheetName
                })
            }
        })
    }

    compareAndApplyP2Conditions = (key, data) => {
        this.props.compareSmartspotTemplateColumns(data, {
            onSuccess: (res) => {
                if (!res.hasExistingConditions) {
                    this.setState({ [this._p2StateKey(key, 'Col')]: [] }); return
                }
                if (res.columnsMatch) {
                    this.setState({ [this._p2StateKey(key, 'Col')]: res.preservableConditions })
                    alert(`Template uploaded!\n\n✅ All ${res.preservableConditions.length} conditions preserved.`)
                } else if (res.preservableCount > 0) {
                    this.setState({
                        [this._p2StateKey(key, 'Col')]: res.preservableConditions,
                        [this._p2StateKey(key, 'ComparisonModalOpen')]: true,
                        [this._p2StateKey(key, 'ComparisonResult')]: res,
                    })
                } else {
                    this.setState({ [this._p2StateKey(key, 'Col')]: [] })
                    alert(`Template uploaded!\n\n⚠️ New template has different columns. All conditions cleared.`)
                }
            },
            onFailure: () => { this.setState({ [this._p2StateKey(key, 'Col')]: [] }) }
        })
    }

    openP2ConditionsModal = () => {
        if (!this._templateId) { alert('Please select a Template Month.'); return }
        if (this.state.phase2TemplateStatus !== 'Available') {
            alert('Please upload the Phase 2 Template file first.')
            return
        }

        // Load conditions for every sheet; extract fresh headers for any sheet with no saved conditions
        SMARTSPOT_PHASE2_TEMPLATES.forEach((tmpl) => {
            const colKey = this._p2StateKey(tmpl.key, 'Col')
            // If already loaded in state, skip the round-trip
            if ((this.state[colKey] || []).length > 0) return

            this.props.getsmartspotTemplateConditions(
                this._templateId,
                tmpl.sheetName,
                {
                    onSuccess: (res) => {
                        if (res.colConditions && res.colConditions.length > 0) {
                            this.setState({ [colKey]: res.colConditions })
                        } else {
                            // No saved conditions — extract column headers from the sheet
                            this.props.extractsmartspotTemplateCol(this._templateId, tmpl.sheetName, {
                                onSuccess: (r) => {
                                    if (r.result && r.result.length) {
                                        this.setState({ [colKey]: r.result })
                                    }
                                },
                                onFailure: () => {}
                            })
                        }
                    },
                    onFailure: () => {}
                }
            )
        })

        this.setState({ phase2ConditionsModalOpen: true, phase2ConditionsActiveTab: 'nonAuditing' })
    }

    // Keep applyP2Conditions as an alias so any residual references still work
    applyP2Conditions = (key) => {
        this.setState({ phase2ConditionsActiveTab: key }, () => this.openP2ConditionsModal())
    }

    saveP2ColTemplate = (key) => {
        const cols = this.state[this._p2StateKey(key, 'Col')] || []
        const errors = []
        for (const col of cols) {
            errors.push(...this._validateMappingRow(col))
        }
        if (errors.length > 0) {
            alert(`Validation Errors:\n\n${errors.map(e => `${e.colName}: ${e.message}`).join('\n')}`)
            return
        }
        const tmpl = SMARTSPOT_PHASE2_TEMPLATES.find(t => t.key === key)
        const sheetName = tmpl ? tmpl.sheetName : key   // sheetName is the DB key
        this.props.savesmartspotTemplateCol(
            { colConditions: cols, templateId: this._templateId, sheetName },
            {
                onSuccess: () => {
                    alert(`Conditions saved for "${tmpl ? tmpl.label : key}"`)
                },
                onFailure: () => { alert('Failed to save conditions') }
            }
        )
    }

    render() {
        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Smartspot Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.fileUrl)}
                    />;
                },
            },
            {
                Header: "Smartpsot DSE",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.dseFileUrl)}
                    />;
                },
            },
            {
                Header: "DSE Upload Status",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if(original.dseClientUpdate == 'pending'){
                        return <Icon name="ban" style={{ marginLeft: 45, cursor: 'pointer' }} color={'orange'} 
                    />;
                    }
                    
                    else{
                        return <Icon name="check circle" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    />;
                    }
                },
            },
            {
                Header: "Credit Note Process Status",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if(original.creditNoteStatus == 'pending'){
                        return <Icon name="ban" style={{ marginLeft: 45, cursor: 'pointer' }} color={'orange'} 
                    />;
                    }
                    
                    else{
                        return <Icon name="check circle" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    />;
                    }
                },
            },
            {
                Header: "Smartspot Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.creditNoteUrl)}
                    disabled={original.creditNoteStatus != 'pending'?false:true}
                    />;
                },
            }
        ];

        const non_auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Smartspot Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.fileUrl)}
                    />;
                },
            },
            {
                Header: "Smartspot DSE",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.dseFileUrl)}
                    />;
                },
            },
            {
                Header: "DSE Upload Status",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if(original.dseClientUpdate == 'pending'){
                        return <Icon name="ban" style={{ marginLeft: 45, cursor: 'pointer' }} color={'orange'} 
                    />;
                    }
                    
                    else{
                        return <Icon name="check circle" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    />;
                    }
                },
            },
            {
                Header: "Credit Note Process Status",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if(original.creditNoteStatus == 'pending'){
                        return <Icon name="ban" style={{ marginLeft: 45, cursor: 'pointer' }} color={'orange'} 
                    />;
                    }
                    
                    else{
                        return <Icon name="check circle" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    />;
                    }
                },
            },
            {
                Header: "Smartspot Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.creditNoteUrl)}
                    disabled={original.creditNoteStatus != 'pending'?false:true}
                    />;
                },
            }
        ]

        var fileType = [
            { key: 'Minimarket - Final Master', value: 'Minimarket - Final Master', text: 'Minimarket - Final Master' },
            { key: 'Channel 1 Target', value: 'Channel 1 Target', text: 'Channel 1 Target' },
            { key: 'PSR Target', value: 'PSR Target', text: 'PSR Target' },
            { key: 'SGF Fixed rack rate', value: 'SGF Fixed rack rate', text: 'SGF Fixed rack rate' },
            { key: 'Audit Summary File', value: 'Audit Summary File', text: 'Audit Summary File' },
            { key: 'P&G Target', value: 'P&G Target', text: 'P&G Target' },
            { key: 'Formula', value: 'Formula', text: 'Formula' },
            { key: 'Plan Data', value: 'Plan Data', text: 'Plan Data' }
        ]

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Dimmer active={this.state.loaderStatus}>
                    <Loader size="massive">File Processing.....</Loader>
                </Dimmer>
                </div>

                <Grid columns={3} style={{ marginTop: 20 }}>
                    {/* smartspot - standalone stores */}
                    <GridColumn>
                        <Card.Group>
                            <h2 style={{marginLeft: 10 }}>Standalone Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h4>{`Minimarket Standalone Automation `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <strong style={{ color: this.state.automationStatus == 'Completed' ? 'green' : this.state.automationStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.automationStatus}</strong></h4>
                                        {this.state.errorMessage && (
                                            <div style={{ marginTop: 10, padding: 10, backgroundColor: '#fff6f6', border: '1px solid #e0b4b4', borderRadius: 4 }}>
                                                <p style={{ color: '#9f3a38', margin: 0, fontSize: '0.9em' }}>
                                                    <Icon name="exclamation triangle" />
                                                    {this.state.errorMessage}
                                                </p>
                                            </div>
                                        )}
                                    </Card.Description>
                                    <br></br>

                                </Card.Content>
                                <Card.Content extra>

                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial == true && this.state.automationStatus !== 'Failed' && this.state.automationStatus !== 'Processing' && (
                                            <Button basic color='green'
                                                onClick={() => this.openStandaloneModal()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {(this.state.initial == false || this.state.automationStatus === 'Failed') && this.state.automationStatus !== 'Processing' && (
                                            <Button basic color='orange'
                                                onClick={() => this.openStandaloneModal()}
                                            >
                                                <Icon name="redo" />
                                                Re-Start
                                            </Button>
                                        )}
                                        {this.state.automationStatus === 'Processing' && (
                                            <Button basic color='orange' loading disabled>
                                                Processing...
                                            </Button>
                                        )}
                                    </div>

                                    {/* Re-Start Confirmation Modal */}
                                    <Modal
                                        open={this.state.restartConfirmOpen}
                                        size='small'
                                        onClose={() => this.setState({ restartConfirmOpen: false })}
                                    >
                                        <Modal.Header>Confirm Re-Start</Modal.Header>
                                        <Modal.Content>
                                            <p>Are you sure you want to re-process the Smartspot automation for this template? The existing output will be overwritten.</p>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='red' onClick={() => this.setState({ restartConfirmOpen: false })}>
                                                <Icon name='remove' /> Cancel
                                            </Button>
                                            <Button color='green' onClick={() => this.restart()}>
                                                <Icon name='checkmark' /> Yes, Re-Start
                                            </Button>
                                        </Modal.Actions>
                                    </Modal>

                                </Card.Content>
                            </Card>

                        </Card.Group>
                    </GridColumn>
                    
                    {/* smartspot phase 2 */}
                    <GridColumn>
                        <Card.Group>
                            <h2 style={{marginLeft: 10 }}>Smartspot Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h4>
                                            {`Smartspot Automation`}&nbsp;: <strong style={{ color: this.state.phase2AutomationStatus === 'Completed' ? 'green' : this.state.phase2AutomationStatus === 'Processing' ? 'orange' : this.state.phase2AutomationStatus === 'Failed' ? 'red' : '#888' }}>{this.state.phase2AutomationStatus}</strong>
                                        </h4>
                                        {this.state.phase2ErrorMessage && (
                                            <div style={{ marginTop: 6, padding: 8, backgroundColor: '#fff6f6', border: '1px solid #e0b4b4', borderRadius: 4 }}>
                                                <p style={{ color: '#9f3a38', margin: 0, fontSize: '0.85em' }}>
                                                    <Icon name="exclamation triangle" />
                                                    {this.state.phase2ErrorMessage}
                                                </p>
                                            </div>
                                        )}
                                    </Card.Description>
                                    <br />
                                </Card.Content>
                                <Card.Content extra>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 6 }}>
                                        {/* Open — only shown when not yet started or pending */}
                                        {(this.state.phase2AutomationStatus === 'Pending' || this.state.phase2AutomationStatus === 'Not Started') && (
                                            <Button basic color='green'
                                                onClick={() => this.openPhase2Modal()}
                                                disabled={this.state.automationStatus !== 'Completed'}
                                                title={this.state.automationStatus !== 'Completed' ? 'Complete Standalone first' : ''}
                                            >
                                                <Icon name="folder open" /> Open
                                            </Button>
                                        )}
                                        {this.state.phase2AutomationStatus === 'Completed' && (
                                            <Button basic color='blue'
                                                onClick={() => this.downloadfile(this.state.phase2OutputUrl)}
                                            >
                                                <Icon name="download" /> Download
                                            </Button>
                                        )}
                                        {/* Re-Start — shown after completion or failure */}
                                        {(this.state.phase2AutomationStatus === 'Completed' || this.state.phase2AutomationStatus === 'Failed') && (
                                            <Button basic color='orange'
                                                onClick={() => this.openPhase2Modal()}
                                            >
                                                <Icon name="redo" /> Re-Start
                                            </Button>
                                        )}
                                    </div>
                                    {this.state.automationStatus !== 'Completed' && this.state.phase2AutomationStatus === 'Pending' && (
                                        <div style={{ textAlign: 'center', marginTop: 8, fontSize: '0.8em', color: '#999' }}>
                                            <Icon name="lock" /> Complete Standalone first
                                        </div>
                                    )}
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>
                    {/* <GridColumn style={{ display: 'flex', flexDirection: 'row' }}>

                        <Card.Group>
                            <h2>Automation Result</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h3 style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>{`Auditing Sites  `}
                                        <Icon name="arrow circle down" style={{ marginLeft: 75, cursor: 'pointer' }} color={'green'}
                                        disabled={this.state.downloadEnable == true ? false : true} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.automationSplitFiles[0].result[0])}
                                        />
                                        <Icon name="pencil alternate" style={{  cursor: 'pointer' }} color={'green'} 
                                        onClick={() => this.formulasModal('NonAuditing - Large')}
                                        />
                                        </h3>
                                    </Card.Description>
                                    <br></br>
                                    <br></br>
                               
                                    <Card.Description>
                                        <h3 style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>{`Non Auditing Sites  `}<Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                                        disabled={this.state.downloadEnable == true ? false : true} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.automationSplitFiles[1].result[0])}
                                        />
                                        <Icon name="pencil alternate" style={{  cursor: 'pointer' }} color={'green'} 
                                        onClick={() => this.formulasModal('NonAuditing - Medium')}
                                        />
                                        </h3>
                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                        <br></br>

                    </GridColumn> */}
                    {/* <GridColumn>
                        <Card.Group>
                            <h2>Approved Disbursement</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                     <Card.Description>
                                        <h3 style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>{'Auditing Sites'} <Icon name="upload" style={{ marginLeft: 65, cursor: 'pointer' }} color={'orange'} 
                                        onClick={() => this.uploadFile('smartspotAuditing', 'smartspotAuditing')}
                                        /><Icon name="arrow circle down" style={{ marginLeft:25, cursor: 'pointer' }} color={'green'} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.workingFiles[0].result[0])}
                                        /></h3>
                                        
                                    </Card.Description>
                                    <br></br>
                                    <br></br>
                               
                                    <Card.Description>
                                    <h3 style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>{'Non-Auditing Sites'} <Icon name="upload" style={{ marginLeft: 25, cursor: 'pointer' }} color={'orange'} 
                                        onClick={() => this.uploadFile('smartspotNonAuditing', 'smartspotNonAuditing')}
                                        /><Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.workingFiles[1].result[0])}
                                        /></h3>
                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn> */}
                    </Grid>
                    {/* <br></br>
                    <br></br>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <div>
                        <p style={{ fontSize: 25 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#2185d0",
                                }}
                            >
                                Disbursement Working for Sites
                            </h1>
                        </p>
                        </div>

                        <div>
                            <Label
                                style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                                size="large"
                                color="blue"
                                onClick={()=>this.splitFiles()}
                            >

                                Split Files
                                <Icon name="file" style={{ marginLeft: 10 }} />
                            </Label>
                        </div>
                        <div>
                            <Label
                                style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                                size="large"
                                color="blue"
                                onClick={()=>this.releaseWorking()}
                            >

                                Release Workings
                                <Icon name="envelope" style={{ marginLeft: 10 }} />
                            </Label>
                        </div>
                        <div>
                            <Label
                                style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                                size="large"
                                color="blue"
                                onClick={()=>this.processCreditNotes()}
                            >

                                Process CreditNote
                                <Icon name="file" style={{ marginLeft: 10 }} />
                            </Label>
                        </div>
                        <div>
                            <Label
                                style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                                size="large"
                                color="blue"
                                onClick={()=>this.releaseCreditNote()}
                            >

                                Release CreditNote
                                <Icon name="envelope" style={{ marginLeft: 10 }} />
                            </Label>
                        </div>
                    
                    </div>
                    
                        
                        <p style={{ fontSize: 18 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#0000000",
                                }}
                            >
                                Auditing Sites
                            </h1>
                        </p>
                    <CheckboxTable
                        data={this.state.auditingSplit}
                        columns={auditing_split_columns}
                        sendedData={this.siteData}
                    />
                    <br></br>
                    <br></br>
                    <p style={{ fontSize: 18 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#0000000",
                                }}
                            >
                                Non Auditing Sites
                            </h1>
                        </p>
                    <CheckboxTable
                        data={this.state.nonAuditingSplit}
                        columns={non_auditing_split_columns}
                        sendedData={this.siteData}
                    /> */}

                    <Modal
                        open={this.state.formulaModalOpen}
                        onClose={this.closeFormulaModal}
                        size="normal"
                    >
                        <Modal.Content>
                            <Form>
                                <strong>{`IF No formula for a column please specifiy the column as like "A -- No Formula"`}</strong>
                                {this.state.formulas.length > 0 && this.state.formulas.map((d) => {
                                    return (
                                        <Grid columns={1}>
                                            <Grid.Row>
                                                <GridColumn style={{ marginTop: 20 }}>
                                                    <Form.Input
                                                        type="any"
                                                        label={Object.keys(d)[0]}
                                                        value={Object.values(d)[0]}
                                                        onChange={(e) => this.formulaOnChange(e, d)}
                                                        placeholder={Object.values(d)[0]}
                                                    />
                                                </GridColumn>
                                            </Grid.Row>
                                        </Grid>
                                    )

                                })}



                            </Form>
                        </Modal.Content>

                        <Modal.Actions>
                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                                <ButtonHandler
                                    click={this.saveFormulas}
                                    title={'Save'}
                                    color={'green'}
                                    iconColor={'white'}
                                />
                                <ButtonHandler
                                    click={this.closeFormulaModal}
                                    isIcon={true}
                                    color={'red'}
                                    iconName={'remove'}
                                    iconColor={'white'}
                                    title={'Close'}
                                />
                            </div>

                        </Modal.Actions>
                    </Modal>
                    
                    <Modal
                        open={this.state.modalOpen}
                        onClose={this.closeuploadoption}
                        size="mini"
                    >
                        <Modal.Content>
                            <Form>
                                <Grid columns={1}>
                                    <Grid.Row>

                                        <Grid.Column style={{ marginTop: 20 }}>
                                            <h4>Upload Master data :</h4>
                                            <Input
                                                type="file"
                                                accept=".xlsx"
                                                onChange={this.fileupload}
                                                multiple
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Content>

                        <Modal.Actions>
                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                                <ButtonHandler
                                    click={this.uploadRawFile}
                                    title={'Upload'}
                                    color={'green'}
                                    iconColor={'white'}
                                    disabled={this.state.fileUploaded == true ? false : true}
                                />
                                <ButtonHandler
                                    click={this.closeuploadoption}
                                    isIcon={true}
                                    color={'red'}
                                    iconName={'remove'}
                                    iconColor={'white'}
                                    title={'Close'}
                                />
                            </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                    <Dimmer active inverted>
                    <Loader inverted>Loading</Loader>
                    </Dimmer>
                )}
                </Modal>

                {/* Input Files Modal */}
                <Modal
                    open={this.state.inputFilesModalOpen}
                    onClose={() => this.setState({ inputFilesModalOpen: false })}
                    size="small"
                >
                    <Modal.Header>
                        <Icon name="folder open" color="blue" />
                        Smartspot Input Files
                    </Modal.Header>
                    <Modal.Content>
                        <Grid columns={3}>
                            <Grid.Row>
                                <Grid.Column><strong>File Name</strong></Grid.Column>
                                <Grid.Column><strong>Status</strong></Grid.Column>
                                <Grid.Column><strong>Actions</strong></Grid.Column>
                            </Grid.Row>
                        </Grid>
                        {this.state.inputFileStatusList.map((file, idx) => (
                            <Grid columns={3} key={idx} style={{ marginTop: 8 }}>
                                <Grid.Row>
                                    <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                        {file.fileName === 'PSR Target' ? 'PSR' : file.fileName}
                                    </Grid.Column>
                                    <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                        {file.status === 'Available'
                                            ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                            : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                        }
                                    </Grid.Column>
                                    <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        {(() => {
                                            const isSystemManagedFile = ['PSR Target', 'Channel 1 Target'].includes(file.fileName)
                                            return (
                                                <>
                                        <Icon 
                                            name="upload" 
                                            color="orange" 
                                            size="large"
                                            style={{ 
                                                    cursor: isSystemManagedFile ? 'not-allowed' : 'pointer',
                                                    opacity: isSystemManagedFile ? 0.3 : 1
                                            }}
                                            onClick={() => {
                                                    if (!isSystemManagedFile) {
                                                    this.uploadFile(file.fileName, file.fileName)
                                                }
                                            }}
                                        />
                                                    {file.status === 'Available' && file.downloadUrl && (
                                            <Icon
                                                name="arrow circle down"
                                                color="green"
                                                size="large"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => this.downloadfile(file.downloadUrl)}
                                            />
                                        )}
                                                </>
                                            )
                                        })()}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        ))}
                        {this.state.loaderStatus && (
                            <Dimmer active inverted>
                                <Loader inverted>Uploading...</Loader>
                            </Dimmer>
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ inputFilesModalOpen: false })}>
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>

                
                {/* Plan Data Modal */}
                <Modal
                    open={this.state.planDataModalOpen}
                    onClose={() => this.setState({ planDataModalOpen: false })}
                    size="small"
                >
                    <Modal.Header>
                        <Icon name="database" color="blue" />
                        Smartspot Plan Data
                    </Modal.Header>
                    <Modal.Content>
                        <Grid columns={3}>
                            <Grid.Row>
                                <Grid.Column><strong>File Name</strong></Grid.Column>
                                <Grid.Column><strong>Status</strong></Grid.Column>
                                <Grid.Column><strong>Actions</strong></Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    smartspotPlanData
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.planDataStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <Icon 
                                        name="upload" 
                                        color="orange" 
                                        size="large"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            this.uploadFile('smartspotStandalonePlanData', 'smartspotStandalonePlanData')
                                        }}
                                    />
                                    {this.state.planDataStatus === 'Available' && this.state.planDataUrl && (
                                        <Icon
                                            name="arrow circle down"
                                            color="green"
                                            size="large"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.planDataUrl)}
                                        />
                                    )}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ planDataModalOpen: false })}>Close</Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    open={this.state.templateModalOpen}
                    onClose={() => this.setState({ templateModalOpen: false })}
                    size='small'
                >
                    <Modal.Header>
                        <Icon name="file excel" color="blue" />
                        Smartspot Standalone Template File - {this.state.auditType}
                    </Modal.Header>
                    <Modal.Content>
                        <Grid columns={3}>
                            <Grid.Row>
                                <Grid.Column><strong>File Name</strong></Grid.Column>
                                <Grid.Column><strong>Status</strong></Grid.Column>
                                <Grid.Column><strong>Action</strong></Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column style={{display:'flex', alignItems:'center'}}>
                                    {this._standaloneTemplateKey}
                                </Grid.Column>
                                <Grid.Column style={{display:'flex', alignItems:'center'}}>
                                    {
                                        this.state.templateStatus === 'Available'
                                        ? <span style={{color:'green'}}><Icon name="check circle" />Available</span>
                                        : <span style={{color: 'red'}}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{display:'flex', alignItems:'center', gap:10}}>
                                    <Icon
                                        name="upload"
                                        color="orange"
                                        size="large"
                                        style={{cursor: 'pointer'}}
                                        onClick={()=> {
                                            this.uploadFile(this._standaloneTemplateKey, this._standaloneTemplateKey)
                                        }}
                                    />
                                    {
                                        this.state.templateStatus === 'Available'
                                        && this.state.templateDataUrl
                                        && (
                                            <Icon
                                                name="arrow circle down"
                                                color="green"
                                                size="large"
                                                style={{cursor: 'pointer'}}
                                                onClick={()=> this.downloadfile(this.state.templateDataUrl)}
                                            />
                                        )
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={()=>this.setState({templateModalOpen:false})}>
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Smartspot Mapping File Modal */}
                <Modal
                    open={this.state.mappingFileModalOpen}
                    onClose={() => this.setState({ mappingFileModalOpen: false })}
                    size='small'
                >
                    <Modal.Header>
                        <Icon name="map" color="blue" />
                        Smartspot Mapping File
                    </Modal.Header>
                    <Modal.Content>
                        <Grid columns={3}>
                            <Grid.Row>
                                <Grid.Column><strong>File Name</strong></Grid.Column>
                                <Grid.Column><strong>Status</strong></Grid.Column>
                                <Grid.Column><strong>Actions</strong></Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    smartspotMappingFile
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.mappingFileStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <label style={{ cursor: 'pointer', margin: 0 }}>
                                        <Icon name="upload" color="orange" size="large" />
                                        <input
                                            type="file"
                                            accept=".xlsx"
                                            style={{ display: 'none' }}
                                            onChange={(e) => {
                                                const file = e.target.files[0]
                                                if (file) {
                                                    this.setState(
                                                        { mappingCurrentFile: file, mappingFileUploaded: true },
                                                        () => this.uploadMappingFile()
                                                    )
                                                }
                                                e.target.value = ''
                                            }}
                                        />
                                    </label>
                                    {this.state.mappingFileStatus === 'Available' && this.state.mappingFileUrl && (
                                        <Icon
                                            name="arrow circle down"
                                            color="green"
                                            size="large"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.mappingFileUrl)}
                                        />
                                    )}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ mappingFileModalOpen: false })}>Close</Button>
                    </Modal.Actions>
                </Modal>

                {/* Apply condition Modal */}
                {/* <Modal
                    open={this.state.templateColModal}
                    onClose={this.closeFormulaModal}
                    size="large"
                >
                    <Modal.Content>
                        <Grid columns={3}>
                            <Grid.Column><h4>Header</h4></Grid.Column>
                            <Grid.Column><h4>File Type</h4></Grid.Column>
                            <Grid.Column><h4>Column Number</h4></Grid.Column>
                        </Grid>
                        {this.state.templateCol.map(
                            (d) => (
                                <Grid columns={3} key={d.colName}>
                                    <Grid.Row>
                                        <Grid.Column style={{marginTop: 20}}>{d.colName}</Grid.Column>
                                        <Grid.Column style={{marginTop: 20}}> 
                                            <Dropdown
                                                placeholder='Select File Types'
                                                search
                                                multiple
                                                selection
                                                options={fileType}
                                                onChange={this.dropDownColOnChange}
                                                additionLabel={d.colName}
                                                value={d.fileType}
                                            />
                                        </Grid.Column>
                                        <Grid.Column style={{marginTop: 20}}>
                                            <TextArea 
                                                style={{width: '100%'}}
                                                value={d.colNum}
                                                onChange={(e)=>this.fileColOnChange(e, d)}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            )
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent:'flex-end'}}>
                            <ButtonHandler 
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                                click={this.saveFileColTemplate} 
                            />
                            <ButtonHandler 
                                title={'Close'}
                                color={'red'}
                                iconColor={'white'}
                                click={this.closeFormulaModal}
                            />
                        </div>
                    </Modal.Actions>
                </Modal> */}

                {/* Apply Conditions Modal */}
                <Modal
                    open={this.state.templateColModal}
                    onClose={this.closeFormulaModal}
                    size="large"
                >
                    <Modal.Header>Apply Column Conditions</Modal.Header>
                    <Modal.Content scrolling>
                        <Form>
                            <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#f0f8ff', borderRadius: '5px' }}>
                                <strong>Instructions:</strong>
                                <ul style={{ marginTop: '10px', marginBottom: '0' }}>
                                    <li>For <strong>single input</strong>: Select one file type (e.g., "PSR")</li>
                                    <li>For <strong>multiple inputs</strong>: Type file types separated by " / " (e.g., "Audit Summary File / Plan Data")</li>
                                    <li>Column numbers must match the number of file types (e.g., "A,B / C" for two inputs)</li>
                                </ul>
                            </div>

                            {this.state.templateCol.length > 0 && this.state.templateCol.map((col, index) => {
                                return (
                                    <div key={index} style={{ 
                                        marginBottom: '20px', 
                                        padding: '15px', 
                                        border: '1px solid #ddd', 
                                        borderRadius: '5px',
                                        backgroundColor: '#fafafa'
                                    }}>
                                        <Grid columns={2}>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <Form.Field>
                                                        <label style={{ fontWeight: 'bold', color: '#2185d0' }}>
                                                            Column: {col.colName}
                                                        </label>
                                                        <label style={{ fontSize: '0.9em', color: '#666' }}>
                                                            Excel Column: {col.colIdx}
                                                        </label>
                                                    </Form.Field>
                                                </Grid.Column>
                                            </Grid.Row>
                                            
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <Form.Field>
                                                        <label>File Type</label>
                                                        <Input
                                                            placeholder="e.g., PSR or Audit Summary File / Plan Data"
                                                            value={col.fileType || ''}
                                                            onChange={(e) => {
                                                                const templateCol = this.state.templateCol.map((c) => {
                                                                    if (c.colName === col.colName) {
                                                                        return { ...c, fileType: e.target.value }
                                                                    }
                                                                    return c
                                                                })
                                                                this.setState({ templateCol })
                                                            }}
                                                        />
                                                        <div style={{ marginTop: '5px' }}>
                                                            <label style={{ fontSize: '0.85em', color: '#666' }}>
                                                                Quick select:
                                                            </label>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '5px' }}>
                                                                {[
                                                                    'Minimarket - Final Master',
                                                                    'Channel 1 Target',
                                                                    'Channel 1 Target || Audit Summary File',
                                                                    'PSR',
                                                                    'DGP',
                                                                    'SGF Fixed rack rate',
                                                                    'Audit Summary File',
                                                                    'P&G Target',
                                                                    'Plan Data',
                                                                    'Formula',
                                                                    'Audit Summary File / Plan Data'
                                                                ].map((fileType) => (
                                                                    <Label
                                                                        key={fileType}
                                                                        as='a'
                                                                        size='tiny'
                                                                        color='blue'
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => {
                                                                            const templateCol = this.state.templateCol.map((c) => {
                                                                                if (c.colName === col.colName) {
                                                                                    return { ...c, fileType: fileType }
                                                                                }
                                                                                return c
                                                                            })
                                                                            this.setState({ templateCol })
                                                                        }}
                                                                    >
                                                                        {fileType}
                                                                    </Label>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Form.Field>
                                                </Grid.Column>
                                                
                                                <Grid.Column>
                                                    <Form.Field>
                                                        <label>Column Number</label>
                                                        <Input
                                                            placeholder="e.g., A,B or A,B / C"
                                                            value={col.colNum || ''}
                                                            onChange={(e) => {
                                                                const templateCol = this.state.templateCol.map((c) => {
                                                                    if (c.colName === col.colName) {
                                                                        return { ...c, colNum: e.target.value }
                                                                    }
                                                                    return c
                                                                })
                                                                this.setState({ templateCol })
                                                            }}
                                                        />
                                                        <label style={{ fontSize: '0.85em', color: '#666', marginTop: '5px', display: 'block' }}>
                                                            {col.fileType && col.fileType.includes('/') 
                                                                ? '⚠️ Multi-input: Use "/" to separate column numbers (e.g., "A,B / C")'
                                                                : 'Single input: Enter column letters (e.g., "A,B")'}
                                                        </label>
                                                    </Form.Field>
                                                </Grid.Column>
                                            </Grid.Row>
                                            
                                            {/* Validation indicator */}
                                            {col.fileType && col.colNum && (() => {
                                                // Formula type uses Excel formulas — skip '/' split validation
                                                if (col.fileType.trim() === 'Formula') {
                                                    return (
                                                        <Grid.Row>
                                                            <Grid.Column width={16}>
                                                                <div style={{ 
                                                                    padding: '8px', 
                                                                    backgroundColor: '#d4edda', 
                                                                    border: '1px solid #28a745',
                                                                    borderRadius: '3px',
                                                                    color: '#155724',
                                                                    fontSize: '0.9em'
                                                                }}>
                                                                    <Icon name='check circle' />
                                                                    Valid: Formula configured
                                                                </div>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    );
                                                }

                                                const fileTypes = col.fileType.split('/').map(s => s.trim()).filter(s => s);
                                                const colNums = col.colNum.split('/').map(s => s.trim()).filter(s => s);
                                                const isValid = fileTypes.length === colNums.length;
                                                
                                                return !isValid ? (
                                                    <Grid.Row>
                                                        <Grid.Column width={16}>
                                                            <div style={{ 
                                                                padding: '10px', 
                                                                backgroundColor: '#fff3cd', 
                                                                border: '1px solid #ffc107',
                                                                borderRadius: '3px',
                                                                color: '#856404'
                                                            }}>
                                                                <Icon name='warning sign' />
                                                                Mismatch: {fileTypes.length} file type(s) but {colNums.length} column number(s). They must match!
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                ) : (
                                                    <Grid.Row>
                                                        <Grid.Column width={16}>
                                                            <div style={{ 
                                                                padding: '8px', 
                                                                backgroundColor: '#d4edda', 
                                                                border: '1px solid #28a745',
                                                                borderRadius: '3px',
                                                                color: '#155724',
                                                                fontSize: '0.9em'
                                                            }}>
                                                                <Icon name='check circle' />
                                                                Valid: {fileTypes.length} input(s) configured
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                );
                                            })()}
                                        </Grid>
                                    </div>
                                )
                            })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: 'center' }}>
                            <div style={{ fontSize: '0.9em', color: '#666' }}>
                                {this.state.templateCol.length} columns configured
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <ButtonHandler
                                    click={this.saveFileColTemplate}
                                    title={'Save Conditions'}
                                    color={'green'}
                                    iconColor={'white'}
                                />
                                <ButtonHandler
                                    click={this.closeFormulaModal}
                                    isIcon={true}
                                    color={'red'}
                                    iconName={'remove'}
                                    iconColor={'white'}
                                    title={'Close'}
                                />
                            </div>
                        </div>
                    </Modal.Actions>
                </Modal>


                {/* upload confirmation modal */}
                <Modal
                    open={this.state.templateUploadConfirmModalOpen}
                    onClose={this.cancelTemplateUpload}
                    size='small'
                >
                    <Modal.Header>
                        <Icon name='warning sign' color='orange' /> Confirm Template Upload
                    </Modal.Header>
                    <Modal.Content>
                        <h3>⚠️ This will modify your Apply Conditions</h3>
                        {
                            this.state.previousMonthInfo 
                            && this.state.previousMonthInfo.previousTemplateId
                            && (
                                <div style={{padding:15, backgroundColor: '#e8f5e9', borderRadius:5, marginTop:15}}>
                                    <Icon name='history' color='green' />
                                    <strong>Previous Month: {this.state.previousMonthInfo.previousTemplateName}</strong>
                                    <p style={{marginLeft:25, marginTop:8, color: '#555'}}>
                                        Matching columns will copy conditions from previous month.
                                        New columns will be added empty. Removed columns will be discarded.
                                    </p>
                                </div>
                            )
                        }
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.cancelTemplateUpload}>Cancel</Button>
                        <Button positive onClick={this.confirmTemplateUpload}>
                            <Icon name='checkmark'/> Proceed with Upload
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* template comparison modal */}
                <Modal open={this.state.templateComparisonModalOpen}
                    onClose={() => this.setState({ templateComparisonModalOpen: false })} size='small'>
                    <Modal.Header>
                        <Icon name='info circle' color='blue' /> Template Column Comparison Results
                    </Modal.Header>
                    <Modal.Content>
                        {this.state.comparisonResult && (() => {
                            const r = this.state.comparisonResult
                            const preserved = r.preservableCount
                            const lost = r.existingConditionsCount - preserved
                            const newCols = r.totalColumns - preserved
                            return (
                                <>
                                    <div style={{ padding: 15, backgroundColor: '#e8f5e9', borderRadius: 5, marginBottom: 10 }}>
                                        <Icon name='check circle' color='green' />
                                        <strong>{preserved} conditions preserved</strong>
                                    </div>
                                    {newCols > 0 && (
                                        <div style={{ padding: 15, backgroundColor: '#e3f2fd', borderRadius: 5, marginBottom: 10 }}>
                                            <Icon name='plus circle' color='blue' />
                                            <strong>{newCols} new columns added (empty)</strong>
                                        </div>
                                    )}
                                    {lost > 0 && (
                                        <div style={{ padding: 15, backgroundColor: '#fff3cd', borderRadius: 5, marginBottom: 10 }}>
                                            <Icon name='warning sign' color='orange' />
                                            <strong>{lost} conditions removed</strong>
                                        </div>
                                    )}
                                </>
                            )
                        })()}
                        <p style={{ marginTop: 15, color: '#888', fontSize: 12 }}>
                            Click "Apply Conditions" to review and adjust the mappings.
                        </p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button primary onClick={() => this.setState({ templateComparisonModalOpen: false })}>
                            <Icon name='checkmark' /> Got it
                        </Button>
                    </Modal.Actions>
                </Modal>


                {/* Minimarket Standalone Modal */}
                <Modal
                    open={this.state.standaloneModalOpen}
                    onClose={this.closeStandaloneModal}
                    size="small"
                >
                    <Modal.Header>
                        <Icon name="folder open" color="blue" />
                        Minimarket Standalone Automation - Input Files
                        <Icon
                            name="close"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onClick={this.closeStandaloneModal}
                        />
                        <div style={{ fontSize: '0.75em', fontWeight: 'normal', color: '#555', marginTop: 6 }}>
                            <Icon name="calendar alternate outline" />
                            {this._selectedTemplate}
                        </div>
                    </Modal.Header>
                    <Modal.Content>
                        <div style={{ marginBottom: this.state.auditType ? 16 : 0, padding: '10px 14px', backgroundColor: '#f8f9fa', borderRadius: 6, border: '1px solid #e9ecef' }}>
                            <strong style={{ display: 'block', marginBottom: 8, fontSize: '0.95em' }}>Audit Type</strong>
                            <Dropdown
                                placeholder='Select Audit Type'
                                selection
                                fluid
                                value={this.state.auditType || null}
                                options={[
                                    { key: 'physical-seller', text: 'Physical + Seller', value: 'Physical + Seller' },
                                    { key: 'seller', text: 'Seller', value: 'Seller' }
                                ]}
                                onChange={this.handleAuditTypeChange}
                            />
                        </div>

                        {this.state.auditType ? (
                            <>
                                <Grid columns={3}>
                                    <Grid.Row>
                                        <Grid.Column><strong>File Name</strong></Grid.Column>
                                        <Grid.Column><strong>Status</strong></Grid.Column>
                                        <Grid.Column><strong>Actions</strong></Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Grid columns={3} style={{ marginTop: 8 }}>
                                    <Grid.Row>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            <strong>Input Files</strong>
                                        </Grid.Column>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            {this.state.inputFileStatusList.length > 0 && this.state.inputFileStatusList.every(f => f.status === 'Available')
                                                ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                                : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                            }
                                        </Grid.Column>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button size='mini' basic color='blue'
                                                onClick={() => this.setState({ inputFilesModalOpen: true },
                                                    () => this.loadInputFilesStatus()
                                                )}
                                            >
                                                <Icon name='folder open' /> Manage
                                            </Button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Grid columns={3} style={{ marginTop: 8 }}>
                                    <Grid.Row>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            <strong>Plan Data</strong>
                                        </Grid.Column>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            {this.state.planDataStatus === 'Available'
                                                ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                                : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                            }
                                        </Grid.Column>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button size='mini' basic color='blue' onClick={() => this.openPlanDataModel()}>
                                                <Icon name='file' /> Manage
                                            </Button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Grid columns={3} style={{ marginTop: 8 }}>
                                    <Grid.Row>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            <strong>Template File</strong>
                                        </Grid.Column>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            {this.state.templateStatus === 'Available'
                                                ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                                : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                            }
                                        </Grid.Column>
                                        <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button size='mini' basic color='blue' onClick={() => this.openTemplateModel()}>
                                                <Icon name='file' /> Manage
                                            </Button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                                    <Button
                                        basic color='blue'
                                        onClick={() => this.applySmartspotConditions()}
                                    >
                                        <Icon name='check' />
                                        Apply Conditions
                                    </Button>
                                    {this.state.auditType === 'Seller' && (
                                        <Button
                                            basic color='teal'
                                            onClick={this.cloneFromPhysicalSeller}
                                            title='Copy matching column conditions from Physical + Seller template'
                                        >
                                            <Icon name='copy' />
                                            Clone from Physical + Seller
                                        </Button>
                                    )}
                                    <span style={{ fontSize: '0.82em', color: this.state.templateCol.length > 0 ? 'green' : '#888' }}>
                                        {this.state.templateCol.length > 0
                                            ? `Column mappings configured (${this.state.templateCol.length} columns)`
                                            : 'Configure column mappings'}
                                    </span>
                                </div>
                            </>
                        ) : (
                            <p style={{ marginTop: 14, color: '#888', fontSize: '0.9em' }}>
                                Select an Audit Type to continue.
                            </p>
                        )}
                        {this.state.loaderStatus && (
                            <Dimmer active inverted>
                                <Loader inverted>Uploading...</Loader>
                            </Dimmer>
                        )}
                    </Modal.Content>
                    <Modal.Actions style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ textAlign: 'left' }}>
                            {this.state.auditType ? (
                                <span style={{ fontSize: '0.9em' }}>
                                    <strong>Report Status: </strong>
                                    {this.state.standaloneStatusByType && this.state.standaloneStatusByType[this.state.auditType === 'Seller' ? 'seller' : 'physical_seller'] === 'Completed' && this.state.standaloneOutputUrls && this.state.standaloneOutputUrls[this.state.auditType === 'Seller' ? 'seller' : 'physical_seller'] ? (
                                        <span style={{ color: 'green', fontWeight: 'bold' }}>
                                            <Icon name="check circle" />
                                            {(() => {
                                                const typeKey = this.state.auditType === 'Seller' ? 'seller' : 'physical_seller';
                                                const updatedAt = this.state.standaloneUpdatedAtByType && this.state.standaloneUpdatedAtByType[typeKey];
                                                if (updatedAt && moment(updatedAt).isValid()) {
                                                    return moment(updatedAt).format('HH:mm - DD/MM/YYYY');
                                                }
                                                return 'Report available';
                                            })()}
                                        </span>
                                    ) : (
                                        <span style={{ color: '#777' }}><Icon name="info circle" />Report not available</span>
                                    )}
                                </span>
                            ) : null}
                        </div>
                        <div>
                            {this.state.auditType && (
                                <Button
                                    basic
                                    color='blue'
                                    disabled={!(this.state.standaloneStatusByType && this.state.standaloneStatusByType[this.state.auditType === 'Seller' ? 'seller' : 'physical_seller'] === 'Completed' && this.state.standaloneOutputUrls && this.state.standaloneOutputUrls[this.state.auditType === 'Seller' ? 'seller' : 'physical_seller'])}
                                    onClick={() => {
                                        const typeKey = this.state.auditType === 'Seller' ? 'seller' : 'physical_seller';
                                        const url = this.state.standaloneOutputUrls && this.state.standaloneOutputUrls[typeKey];
                                        if (url) {
                                            this.downloadfile(url);
                                        }
                                    }}
                                >
                                    <Icon name="download" /> Download Final Report
                                </Button>
                            )}
                            <Button
                                basic color='green'
                                disabled={!this.state.auditType}
                                onClick={() => {
                                if (this.state.initial == true && this.state.automationStatus !== 'Failed') {
                                    this.setState({ standaloneModalOpen: false })
                                    this.start()
                                } else {
                                    this.setState({ standaloneModalOpen: false, restartConfirmOpen: true })
                                }
                            }}>
                                <Icon name="play" /> Start Standalone Automation
                            </Button>
                            <Button onClick={this.closeStandaloneModal}>Close</Button>
                        </div>
                    </Modal.Actions>
                </Modal>


                {/* smartspot phase 2 Modal */}
                <Modal
                    open={this.state.SmartspotFinalReportModalOpen}
                    onClose={this.closePhase2Modal}
                    size="small"
                >
                    <Modal.Header>
                        <Icon name="folder open" color="blue" />
                        Smartspot Automation - Input Files
                        <Icon
                            name="close"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onClick={this.closePhase2Modal}
                        />
                        <div style={{ fontSize: '0.75em', fontWeight: 'normal', color: '#555', marginTop: 6 }}>
                            <Icon name="calendar alternate outline" />
                            {this._selectedTemplate}
                        </div>
                    </Modal.Header>
                    <Modal.Content>
                        {/* Header row */}
                        <Grid columns={3}>
                            <Grid.Row>
                                <Grid.Column><strong>File Name</strong></Grid.Column>
                                <Grid.Column><strong>Status</strong></Grid.Column>
                                <Grid.Column><strong>Actions</strong></Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {/* 1. Standalone Report — upload + download */}
                        <Grid columns={3} style={{ marginTop: 8 }}>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong>Standalone Report</strong>
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.phase2StandaloneReportStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <label style={{ cursor: 'pointer', margin: 0 }}>
                                        <Icon name="upload" color="orange" size="large" />
                                        <input
                                            type="file"
                                            accept=".xlsx"
                                            style={{ display: 'none' }}
                                            onChange={(e) => {
                                                const file = e.target.files[0]
                                                if (file) {
                                                    this.setState({ phase2StandaloneReportCurrentFile: file, phase2StandaloneReportFileUploaded: true },
                                                        () => this.uploadPhase2StandaloneReport()
                                                    )
                                                }
                                                e.target.value = ''
                                            }}
                                        />
                                    </label>
                                    {this.state.phase2StandaloneReportStatus === 'Available' && this.state.phase2StandaloneReportUrl &&
                                        <Icon name="arrow circle down" color="green" size="large" style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.phase2StandaloneReportUrl)} />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {/* 2. i-100 File — upload + download */}
                        <Grid columns={3} style={{ marginTop: 8 }}>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <strong>i-100 File</strong>
                                        <div style={{ fontSize: '0.8em', color: '#888' }}>Source: Matrix Team</div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.phase2I100Status === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <label style={{ cursor: 'pointer', margin: 0 }}>
                                        <Icon name="upload" color="orange" size="large" />
                                        <input
                                            type="file"
                                            accept=".xlsx"
                                            style={{ display: 'none' }}
                                            onChange={(e) => {
                                                const file = e.target.files[0]
                                                if (file) {
                                                    this.setState({ phase2I100CurrentFile: file, phase2I100FileUploaded: true },
                                                        () => this.uploadPhase2I100()
                                                    )
                                                }
                                            }}
                                        />
                                    </label>
                                    {this.state.phase2I100Status === 'Available' && this.state.phase2I100Url &&
                                        <Icon name="arrow circle down" color="green" size="large" style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.phase2I100Url)} />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {/* 2b. Smartspot Mapping File — upload + download */}
                        <Grid columns={3} style={{ marginTop: 8 }}>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <strong>Smartspot Mapping File</strong>
                                        <div style={{ fontSize: '0.8em', color: '#888' }}>Source: Upload</div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.mappingFileStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <label style={{ cursor: 'pointer', margin: 0 }}>
                                        <Icon name="upload" color="orange" size="large" />
                                        <input
                                            type="file"
                                            accept=".xlsx"
                                            style={{ display: 'none' }}
                                            onChange={(e) => {
                                                const file = e.target.files[0]
                                                if (file) {
                                                    this.setState(
                                                        { mappingCurrentFile: file, mappingFileUploaded: true },
                                                        () => this.uploadMappingFile()
                                                    )
                                                }
                                                e.target.value = ''
                                            }}
                                        />
                                    </label>
                                    {this.state.mappingFileStatus === 'Available' && this.state.mappingFileUrl &&
                                        <Icon name="arrow circle down" color="green" size="large" style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.mappingFileUrl)} />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {/* 3. Adaptive Trade Terms — download only */}
                        <Grid columns={3} style={{ marginTop: 8 }}>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <strong>Adaptive Trade Terms</strong>
                                        <div style={{ fontSize: '0.8em', color: '#888' }}>Source: Swift Raw File Processing</div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.phase2AdaptiveTTStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Not Available</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    {this.state.phase2AdaptiveTTStatus === 'Available' && this.state.phase2AdaptiveTTUrl
                                        ? <Icon name="arrow circle down" color="green" size="large" style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.phase2AdaptiveTTUrl)} />
                                        : <Icon name="arrow circle down" color="grey" size="large" style={{ opacity: 0.3 }} />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {/* 4. Chain Master — download only */}
                        <Grid columns={3} style={{ marginTop: 8 }}>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <strong>Chain Master</strong>
                                        <div style={{ fontSize: '0.8em', color: '#888' }}>Source: Swift Raw File Processing</div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.phase2ChainMasterStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Not Available</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    {this.state.phase2ChainMasterStatus === 'Available' && this.state.phase2ChainMasterUrl
                                        ? <Icon name="arrow circle down" color="green" size="large" style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.phase2ChainMasterUrl)} />
                                        : <Icon name="arrow circle down" color="grey" size="large" style={{ opacity: 0.3 }} />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>


                        {/* -- Template files section -- */}
                        <div style={{ marginTop: 20, borderTop: '1px solid #ddd', paddingTop: 12 }}>
                            <strong>Smartspot Template File</strong>
                            <div style={{ fontSize: '0.8em', color: '#888', marginTop: 4 }}>
                                One Excel file with sheets: Non Auditing · Adaptive TT · Adaptive TOT · Chain Stores
                            </div>
                        </div>

                        {/* Single upload row for the combined template */}
                        <Grid columns={3} style={{ marginTop: 8 }}>
                            <Grid.Row>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong>smartspot_template.xlsx</strong>
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                                    {this.state.phase2TemplateStatus === 'Available'
                                        ? <span style={{ color: 'green' }}><Icon name="check circle" />Available</span>
                                        : <span style={{ color: 'red' }}><Icon name="times circle" />Yet to Upload</span>
                                    }
                                </Grid.Column>
                                <Grid.Column style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <label style={{ cursor: 'pointer', margin: 0 }}>
                                        <Icon name="upload" color="orange" size="large" />
                                        <input type="file" accept=".xlsx" style={{ display: 'none' }}
                                            onChange={(e) => {
                                                const file = e.target.files[0]
                                                if (file) this.checkP2TemplatePreviousConditions('nonAuditing', file)
                                                e.target.value = ''
                                            }}
                                        />
                                    </label>
                                    {this.state.phase2TemplateUrl &&
                                        <Icon name="arrow circle down" color="green" size="large"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.downloadfile(this.state.phase2TemplateUrl)}
                                        />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {/* Apply Conditions — single button opens tabbed modal */}
                        <div style={{ marginTop: 14 }}>
                            <Button
                                basic color='blue'
                                disabled={this.state.phase2TemplateStatus !== 'Available'}
                                onClick={() => this.openP2ConditionsModal()}
                            >
                                <Icon name='check' />
                                Apply Conditions
                            </Button>
                            <span style={{ marginLeft: 10, fontSize: '0.82em', color: '#888' }}>
                                Configure column mappings for all 4 output sheets
                            </span>
                        </div>
                        {this.state.loaderStatus && (
                            <Dimmer active inverted>
                                <Loader inverted>Uploading...</Loader>
                            </Dimmer>
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button basic color='green' onClick={() => this.startPhase2()}>
                            <Icon name="play" /> Start Smartspot Automation
                        </Button>
                        <Button onClick={this.closePhase2Modal}>Close</Button>
                    </Modal.Actions>
                </Modal>



                {/* ── Phase 2 tabbed conditions modal ──────────────────────────────── */}
                <Modal
                    open={this.state.phase2ConditionsModalOpen}
                    onClose={() => this.setState({ phase2ConditionsModalOpen: false })}
                    size="large"
                >
                    <Modal.Header>
                        <Icon name="settings" color="blue" />
                        Apply Column Conditions &mdash; Smartspot Template
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {/* Tab bar */}
                        <div style={{ display: 'flex', borderBottom: '2px solid #2185d0', marginBottom: 16 }}>
                            {SMARTSPOT_PHASE2_TEMPLATES.map((tmpl) => {
                                const isActive = this.state.phase2ConditionsActiveTab === tmpl.key
                                const cols = this.state[this._p2StateKey(tmpl.key, 'Col')] || []
                                const configured = cols.filter(c => c.fileType || c.colNum).length
                                return (
                                    <div
                                        key={tmpl.key}
                                        onClick={() => this.setState({ phase2ConditionsActiveTab: tmpl.key })}
                                        style={{
                                            padding: '8px 18px', cursor: 'pointer',
                                            fontWeight: isActive ? 'bold' : 'normal',
                                            color: isActive ? '#2185d0' : '#555',
                                            borderBottom: isActive ? '3px solid #2185d0' : '3px solid transparent',
                                            marginBottom: -2, userSelect: 'none', whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {tmpl.label}
                                        {cols.length > 0 && (
                                            <span style={{ marginLeft: 6, fontSize: '0.75em', color: configured > 0 ? 'green' : '#aaa' }}>
                                                ({configured}/{cols.length})
                                            </span>
                                        )}
                                    </div>
                                )
                            })}
                        </div>

                        {/* Tab content — rendered for the active tab only */}
                        {SMARTSPOT_PHASE2_TEMPLATES.map((tmpl) => {
                            if (this.state.phase2ConditionsActiveTab !== tmpl.key) return null
                            const colKey = this._p2StateKey(tmpl.key, 'Col')
                            const cols = this.state[colKey] || []
                            return (
                                <div key={tmpl.key}>
                                    <div style={{ marginBottom: 14, padding: 10, backgroundColor: '#f0f8ff', borderRadius: 5 }}>
                                        <strong>Instructions — {tmpl.label} (sheet: {tmpl.sheetName})</strong>
                                        <ul style={{ marginTop: 6, marginBottom: 0 }}>
                                            <li>Single input: one file type, e.g. "Standalone Report"</li>
                                            <li>Multiple inputs: separate with " / ", e.g. "Standalone Report / i-100 File"</li>
                                            <li>Fallback mapping for additional rows: use "Primary || Fallback", e.g. "Standalone Report || Adaptive TT Store List"</li>
                                            <li>If "||" is used, Column Number must also use "||", e.g. "D || E"</li>
                                            <li>Column numbers must match file type inputs on each side of "||"</li>
                                        </ul>
                                    </div>
                                    {cols.length === 0 && (
                                        <div style={{ padding: 20, textAlign: 'center', color: '#aaa' }}>
                                            <Icon name="spinner" loading /> Loading columns&hellip;
                                        </div>
                                    )}
                                    <Form>
                                        {cols.map((col, idx) => (
                                            <div key={idx} style={{ marginBottom: 14, padding: 12, border: '1px solid #ddd', borderRadius: 5, backgroundColor: '#fafafa' }}>
                                                <Grid columns={2}>
                                                    <Grid.Row>
                                                        <Grid.Column>
                                                            <label style={{ fontWeight: 'bold', color: '#2185d0' }}>Column: {col.colName}</label>
                                                            <div style={{ fontSize: '0.85em', color: '#666' }}>Excel Column: {col.colIdx}</div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row>
                                                        <Grid.Column>
                                                            <Form.Field>
                                                                <label>File Type</label>
                                                                <Input
                                                                    placeholder='e.g., Standalone Report / i-100 File || Chain Master'
                                                                    value={col.fileType || ''}
                                                                    onChange={(e) => {
                                                                        const updated = cols.map(c => c.colName === col.colName ? { ...c, fileType: e.target.value } : c)
                                                                        this.setState({ [colKey]: updated })
                                                                    }}
                                                                />
                                                                <div style={{ marginTop: 5 }}>
                                                                    <label style={{ fontSize: '0.82em', color: '#666' }}>Quick select:</label>
                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                                                                        {[
                                                                            'Standalone Report',
                                                                            'i-100 File',
                                                                            'Chain Master',
                                                                            'Adaptive Trade Terms',
                                                                            'Adaptive TT Store List',
                                                                            'Standalone Report || Adaptive TT Store List',
                                                                            'Standalone Report || Chain Master',
                                                                            'Formula'
                                                                        ].map((ft) => (
                                                                            <Label key={ft} as='a' size='tiny' color='blue' style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    const updated = cols.map(c => c.colName === col.colName ? { ...c, fileType: ft } : c)
                                                                                    this.setState({ [colKey]: updated })
                                                                                }}
                                                                            >{ft}</Label>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column>
                                                            <Form.Field>
                                                                <label>Column Number</label>
                                                                <Input
                                                                    placeholder='e.g., D / E || F'
                                                                    value={col.colNum || ''}
                                                                    onChange={(e) => {
                                                                        const updated = cols.map(c => c.colName === col.colName ? { ...c, colNum: e.target.value } : c)
                                                                        this.setState({ [colKey]: updated })
                                                                    }}
                                                                />
                                                                <label style={{ fontSize: '0.82em', color: '#666', marginTop: 4, display: 'block' }}>
                                                                    {col.fileType && col.fileType.includes('||')
                                                                        ? '⚠️ Fallback enabled: use "Primary || Fallback" in Column Number too'
                                                                        : col.fileType && col.fileType.includes('/')
                                                                            ? '⚠️ Multi-input: use "/" to separate column numbers'
                                                                            : 'Single input: enter column letters (e.g. "A,B")'}
                                                                </label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </div>
                                        ))}
                                    </Form>
                                </div>
                            )
                        })}
                    </Modal.Content>
                    <Modal.Actions>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ fontSize: '0.88em', color: '#666' }}>
                                {(() => {
                                    const active = SMARTSPOT_PHASE2_TEMPLATES.find(t => t.key === this.state.phase2ConditionsActiveTab)
                                    const cols = active ? (this.state[this._p2StateKey(active.key, 'Col')] || []) : []
                                    return active ? `${active.label}: ${cols.filter(c => c.fileType || c.colNum).length}/${cols.length} columns configured` : ''
                                })()}
                            </div>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <ButtonHandler
                                    click={() => this.saveP2ColTemplate(this.state.phase2ConditionsActiveTab)}
                                    title='Save This Sheet'
                                    color='green'
                                    iconColor='white'
                                />
                                <ButtonHandler
                                    click={() => this.setState({ phase2ConditionsModalOpen: false })}
                                    isIcon title='Close'
                                    color='red'
                                    iconName='remove'
                                    iconColor='white'
                                />
                            </div>
                        </div>
                    </Modal.Actions>
                </Modal>

                {/* Phase 2 upload-confirm + comparison modals (per-sheet, fire on template re-upload) */}
                {SMARTSPOT_PHASE2_TEMPLATES.map((tmpl) => {
                    const uploadConfirmKey   = this._p2StateKey(tmpl.key, 'UploadConfirmModalOpen')
                    const comparisonModalKey = this._p2StateKey(tmpl.key, 'ComparisonModalOpen')
                    const comparisonResultKey= this._p2StateKey(tmpl.key, 'ComparisonResult')
                    const prevMonthKey       = this._p2StateKey(tmpl.key, 'PreviousMonthInfo')
                    return (
                        <React.Fragment key={tmpl.key}>
                            <Modal open={this.state[uploadConfirmKey]} onClose={() => this.cancelP2TemplateUpload(tmpl.key)} size="small">
                                <Modal.Header><Icon name="warning sign" color="orange" /> Confirm Upload &mdash; {tmpl.label}</Modal.Header>
                                <Modal.Content>
                                    <h3>This will modify your Apply Conditions</h3>
                                    {this.state[prevMonthKey] && this.state[prevMonthKey].previousTemplateId && (
                                        <div style={{ padding: 14, backgroundColor: '#e8f5e9', borderRadius: 5, marginTop: 12 }}>
                                            <Icon name="history" color="green" />
                                            <strong>Previous Month: {this.state[prevMonthKey].previousTemplateName}</strong>
                                            <p style={{ marginLeft: 24, marginTop: 6, color: '#555' }}>
                                                Matching columns will copy conditions from previous month. New columns will be added empty.
                                            </p>
                                        </div>
                                    )}
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button onClick={() => this.cancelP2TemplateUpload(tmpl.key)}>Cancel</Button>
                                    <Button positive onClick={() => this.confirmP2TemplateUpload(tmpl.key)}>
                                        <Icon name="checkmark" /> Proceed with Upload
                                    </Button>
                                </Modal.Actions>
                            </Modal>

                            <Modal open={this.state[comparisonModalKey]} onClose={() => this.setState({ [comparisonModalKey]: false })} size="small">
                                <Modal.Header><Icon name="info circle" color="blue" /> Comparison Results &mdash; {tmpl.label}</Modal.Header>
                                <Modal.Content>
                                    {this.state[comparisonResultKey] && (() => {
                                        const r = this.state[comparisonResultKey]
                                        const preserved = r.preservableCount
                                        const lost = r.existingConditionsCount - preserved
                                        const newCols = r.totalColumns - preserved
                                        return (
                                            <>
                                                <div style={{ padding: 14, backgroundColor: '#e8f5e9', borderRadius: 5, marginBottom: 8 }}>
                                                    <Icon name="check circle" color="green" /><strong>{preserved} conditions preserved</strong>
                                                </div>
                                                {newCols > 0 && <div style={{ padding: 14, backgroundColor: '#e3f2fd', borderRadius: 5, marginBottom: 8 }}>
                                                    <Icon name="plus circle" color="blue" /><strong>{newCols} new columns added (empty)</strong>
                                                </div>}
                                                {lost > 0 && <div style={{ padding: 14, backgroundColor: '#fff3cd', borderRadius: 5, marginBottom: 8 }}>
                                                    <Icon name="warning sign" color="orange" /><strong>{lost} conditions removed</strong>
                                                </div>}
                                            </>
                                        )
                                    })()}
                                    <p style={{ marginTop: 12, color: '#888', fontSize: 12 }}>Click "Apply Conditions" to review and adjust.</p>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button primary onClick={() => this.setState({ [comparisonModalKey]: false })}>
                                        <Icon name="checkmark" /> Got it
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        </React.Fragment>
                    )
                })}
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchAutomationStatusData,
            runSmartspotAutomationScript,
            fetchUseraction,
            getDisbursementFormulas,
            updateDisbursementFormulas,
            fetchTemplates,
            getWorkingFiles,
            rawFileProcess,
            getSplitFilesFormulas,
            updateSplitFileFormulas,
            processApprovedFiles,
            splitSitewiseProcess,
            sendWorkingFiles,
            processCreditNote,
            sendCreditNoteFiles,
            splitSmartspotfiles,
            getSmartspotSplitStatus,
            updateSmartspotDistInfo,
            getSmartspotsplittedFiles,
            smartspotSendWorkingFiles,
            processSmartspotCreditNote,
            sendSmartspotCreditNoteFiles,
            checkSmartspotInputData,
            checkSmartspotFinalReportInputs,
            getSmartspotPlanData,
            extractSmartspotTemplateCol,
            extractsmartspotTemplateCol,
            saveSmartspotTemplateCol,
            savesmartspotTemplateCol,
            getSmartspotTemplateConditions,
            compareSmartspotTemplateColumns,
            getSmartspotPreviousMonthTemplate,
            getsmartspotTemplateConditions,
            runSmartspotFinalReportAutomationScript,
            fetchSmartspotFinalReportAutomationStatus,
            clearSmartspotFinalReportFailedStatus,
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SmartspotAutomation));
